<template>
  <div>
    <h6 class="heading-small text-muted mb-4"> Sales Channel {{this.$attrs.action == "Create" ? "Setup" : this.$attrs.action == "Edit" ? "Edit" : ""}}</h6>
    <hr class="mb-0">
    <fieldset :disabled="$attrs.viewMode == true || $attrs.action == 'View' ? true : false">
        <div class="row no-gutters">
            <div class="col-md-2" style="border-right: 1px solid rgb(224, 224, 224);">
                <a-steps direction="vertical" defaultActiveKey="0" :current="step" class="pt-3">
                    <a-popover slot="progressDot" slot-scope="{ index, status, prefixCls }">
                        <template slot="content">
                        <span>step {{ index }} status: {{ status }}</span>
                        </template>
                        <span :class="`${prefixCls}-icon-dot`" />
                    </a-popover>
                    <a-step title="Info" key="0" :status="$attrs.action != 'Create' && $attrs.action !='resume_create' ? 'finish' : ''" @click.prevent="$attrs.action != 'Create' && $attrs.action !='resume_create' ? step=0  : ''" />
                    <a-step title="Product Management" key="1" :status="$attrs.action != 'Create' && $attrs.action !='resume_create' ? 'finish' : ''" @click.prevent="$attrs.action != 'Create' && $attrs.action !='resume_create' ? step=1 : ''" />
                    <a-step v-if="inputType=='online_store' || inputType==''" title="Customizations" key="2" :status="$attrs.action != 'Create' && $attrs.action !='resume_create' ? 'finish' : ''" @click.prevent="$attrs.action != 'Create' && $attrs.action !='resume_create' ? step=2 : ''"/>
                    <a-step title="Settings" key="3" :status="$attrs.action != 'Create' && $attrs.action !='resume_create' ? 'finish' : ''" @click.prevent="$attrs.action != 'Create' && $attrs.action !='resume_create' ? step=3 : '' "/>
                </a-steps>
            </div>
            <div class="col-md-10">
                <a-spin :spinning="spinning">
                    <div class="card mb-3 border-0">
                        <form>
                            <div class="card-body pb-0" v-if="errors.length">
                                <base-alert  type="danger" class="mb-0">
                                    <b>You have the following error(s):</b>
                                    <li v-for="error in errors" :key="error">{{ error }}</li>
                                </base-alert>
                            </div>
                            <div v-show="step == 0" class="card-body">
                                <a-spin :spinning="AuthorizeRedirectLoading">
                                    <h2>Sales Channel Info</h2>
                                    <div class="row ml-3">
                                        <div class="col-md-6">
                                            <base-input alternative="" label="Sales Channel Name" placeholder="Enter name of your sales Channel" v-model="inputName" @change="" input-classes="form-control" required />
                                            <div class="form-group has-label"><label class="form-control-label">
                                                Type
                                                <span>*</span></label>
                                                <a-radio-group v-model="inputTypeStatus" v-on:change="emptyField" :disabled="$attrs.action == 'Edit'" class="w-100 border rounded">
                                                    <a-radio class="w-100 p-2 border-bottom" :style="radioStyle" :value="1">
                                                        Online Store<br>
                                                    <small class="ml-4">This allows you to create your own e-commerce.</small>
                                                    </a-radio>
                                                    <a-radio class="w-100 p-2 border-bottom" :style="radioStyle" :value="2">
                                                        Shopify<br>
                                                        <small class="ml-4"> This allows you to connect your shopify accounts.</small>
                                                    </a-radio>
                                                    <a-radio class="w-100 p-2 border-bottom" :style="radioStyle" :value="3">
                                                        Shopee<br>
                                                        <small class="ml-4">This allows you to connect your shopee accounts.</small>
                                                    </a-radio>
                                                    <a-radio class="w-100 p-2" :style="radioStyle" :value="4">
                                                        Lazada<br>
                                                        <small class="ml-4">This allows you to connect your lazada accounts.</small>
                                                    </a-radio>
                                                    <a-radio class="w-100 p-2" :style="radioStyle" :value="5">
                                                        Zalora<br />
                                                        <small class="ml-4">This allows you to connect your zalora accounts.</small>   
                                                    </a-radio>
                                                    <!-- <a-radio class="w-100 p-2 border-bottom" :style="radioStyle" :value="2">
                                                        Facebook Messenger<br>
                                                        <small class="ml-4">Connect your store to your chatbot e-commerce.</small>
                                                    </a-radio>
                                                    <a-radio class="w-100 p-2" :style="radioStyle" :value="3">
                                                        Social Media<br>
                                                        <small class="ml-4">Allows to post Promotional links to your social media accounts.</small>
                                                    </a-radio> -->
                                                </a-radio-group>
                                            </div>
                                            <div v-if="inputTypeStatus == 2">
                                                <base-input alternative="" readonly label="Shopify Access Token" type="password" placeholder="shopify Access Token" v-model="ShopifyAccessToken" input-classes="form-control" class=" mb-0" required />
                                                <label v-if="ShopifyAccessTokenStatus" class="text-success text-uppercase font-weight-bold">Valid</label>
                                            </div>
                                            <div v-if="inputTypeStatus == 3">
                                                <base-input alternative="" readonly label="Shopee ID" type="password" placeholder="shop id" v-model="ShopeeShopId" input-classes="form-control" required />
                                                <label v-if="ShopeeShopIdStatus" class="text-success text-uppercase font-weight-bold">Valid</label>
                                            </div>
                                            <div v-if="inputTypeStatus == 4">
                                                <base-input alternative="" readonly type="password" label="Lazada Access Token"  placeholder="Lazada Code" v-model="LazadaCode" input-classes="form-control" class=" mb-0" required />
                                                <label v-if="LazadaCodeStatus" class="text-success text-uppercase font-weight-bold">Valid</label>
                                            </div>
                                            <div v-if="inputTypeStatus == 5">
                                                <base-input alternative="" :disabled="ZaloraClientSecretStatus && ZaloraClientIdStatus" label="Zalora Client Id" type="text" placeholder="Zalora Client Id" v-model="ZaloraClientId" input-classes="form-control" required/>
                                                <base-input  alternative="" :disabled="ZaloraClientSecretStatus && ZaloraClientIdStatus" type="password" label="Zalora Client Secret" placeholder="Zalora Client Secret" v-model="ZaloraClientSecret" input-classes="form-control" class="mb-0" required/>
                                                <label v-if="ZaloraClientSecretStatus && ZaloraClientIdStatus" class="text-success text-uppercase font-weight-bold" >Valid</label>
                                            </div>
                                            <div v-if="inputTypeStatus != 1 && ((inputTypeStatus!='' && LazadaCode ==null && ShopeeShopId==null && ShopifyAccessToken==null && inputTypeStatus!=5) || ( inputTypeStatus==5 && ZaloraClientSecret != null && ZaloraClientId != null && ZaloraClientIdStatus == false && ZaloraClientSecretStatus == false))" class="mt-3">
                                                <a-button type="primary" size="large" class="btn float-right mr-0 btn-primary" :loading="AuthorizeLoading" @click.prevent="marketplaceAuthorization(inputTypeStatus)">Authorize
                                                </a-button>
                                            </div>
                                        </div>
                                    </div>
                                </a-spin>
                            </div>
                            <div v-show="step == 1" class="card-body">
                                <div class="row" v-if="inputType=='online_store' || inputType==''">
                                    <div class="col-md-6">
                                        <h2 class="w-100">Collection Definition 
                                            <base-dropdown class="float-right"  v-if="$attrs.action != 'View'" position="right">
                                                <div class="media align-items-center" slot="title">
                                                <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                </div>
                                                <template>
                                                    <div class=" dropdown-header noti-title">
                                                        <h6 class="text-overflow m-0">ACTIONS</h6>
                                                    </div>
                                                    <a-upload
                                                        name="file"
                                                        :multiple="false"
                                                        :remove="handleRemove"
                                                        :fileList="fileList"
                                                        :headers="headers"
                                                        :beforeUpload="uploadCollection">
                                                        <a class="dropdown-item w-100">
                                                            <a-icon type="upload" /> 
                                                            <span>Upload CSV</span>
                                                        </a> 
                                                    </a-upload>
                                                    <a class="dropdown-item" @click.prevent="downloadTemplate('collections')">
                                                        <i class="fa fa-download"></i>
                                                        <span>Download Template</span>
                                                    </a>
                                                </template>
                                            </base-dropdown>
                                        </h2>
                                    </div>
                                </div>
                                <div class="row ml-3" v-if="inputType=='online_store' || inputType==''">
                                    <div class="col-md-6">
                                        <base-input alternative="" label="Collection Name" placeholder="Write collection name" v-model="collectionName" input-classes="form-control"/>
                                        <div class="form-group has-label"><label class="form-control-label">
                                            Collection Description</label>
                                            <textarea class="form-control" label="Collection Name"  id="exampleFormControlTextarea1" v-model="collectionDesc" rows="3" placeholder="Write collection description"></textarea>
                                        </div>
                                        <div class="row mb-4">
                                            <div class="col-md-12">
                                                <base-button type="primary" class="btn float-right mr-0" v-if="editCollectionIndex == null" @click.prevent="addCollection" :disabled="addCollectionLoading">
                                                <a-spin v-if="addCollectionLoading" :spinning="addCollectionLoading" /> Add
                                                </base-button> 
                                                <base-button type="default" :disabled="updateCollectionLoading" class="float-right mr-2 bg-white text-dark" v-if="editCollectionIndex != null" @click.prevent="updateCollection"> 
                                                <a-spin v-if="updateCollectionLoading" :spinning="updateCollectionLoading" /> Update
                                                </base-button>
                                            </div>
                                        </div>                                       
                                        <a-list size="small"
                                            class="demo-loadmore-list border custom-scrollbar-css" style="max-height:15rem;overflow-x:hidden;"
                                            :loading="loading"
                                            item-layout="horizontal"
                                            :data-source="collections"
                                        >
                                            <a-list-item slot="renderItem" slot-scope="item, index" v-if="item.collection_status!='Delete'">
                                                <base-dropdown class="nav-link pr-0 float-right"  v-if="$attrs.action != 'View'" position="left">
                                                    <div class="media align-items-center" slot="title">
                                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                    </div>
                                                    <template>
                                                        <div class=" dropdown-header noti-title">
                                                            <h6 class="text-overflow m-0">ACTIONS</h6>
                                                        </div>
                                                        <a :id="index" class="dropdown-item" @click.prevent="EditCollection(index)">
                                                            <i class="fa fa-edit"></i>
                                                            <span>Edit Collection</span>
                                                        </a>
                                                        <a :id="index" class="dropdown-item" @click="removeCollection(index)">
                                                            <i class="fa fa-trash"></i>
                                                            <span>Delete Collection</span>
                                                        </a>
                                                    </template>
                                                </base-dropdown>
                                                <a-list-item-meta>
                                                        <a slot="title"  href="" class="ml-3">{{ item.collection_name }}</a>
                                                </a-list-item-meta>
                                            </a-list-item>
                                            <div slot="header" class="pl-2 text-uppercase">
                                                Collections
                                            </div>
                                        </a-list>
                                    </div>
                                    <div v-if="ProductFormStatus" v-bind:class="{'col-md-6': ProductFormStatus == true ? true : false}">
                                        <online-store-product-form :visible="ProductFormStatus" v-if="inputType=='online_store'" @closeProductFrom="closeProductFrom" :productIntegrationData="productIntegrationData" @integrationAddProduct="integrationAddProduct" :actionStatus="actionStatus" :salesChannelStatus="$attrs.action" @integrationUpdateProduct="integrationUpdateProduct" :siteId="siteId" :selectedSublocationId="selectedSublocationId" :inventoryPercentage="inventoryPercentage" :salesChannelId="this.$attrs.salesChannelId" @getPostedProductData="getPostedProductData" @allProductsData="allProductsData"></online-store-product-form>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <div v-if="inputType!='online_store'">
                                            <base-input label="Default Site" input-classes="form-control">
                                                <a-select v-model="siteId" class="mr-2" @change="getAllSubLocation">
                                                    <a-select-option v-for="(site,siteIndex) in defaultSitesList" :key="siteIndex" :value="site.id">
                                                    {{site.name}}
                                                    </a-select-option>
                                                </a-select>
                                            </base-input>
                                            <base-input label="Sublocation" input-classes="form-control">
                                                <a-select v-model="selectedSublocationId" class="mr-2">
                                                    <a-select-option v-for="(sub,subIndex) in sublocationList" :key="subIndex" :value="sub.id">
                                                    {{sub.name}}
                                                    </a-select-option>
                                                </a-select>
                                            </base-input>
                                            <base-input label="Inventory Percentage" input-classes="form-control">
                                            <br>
                                                <a-input-number
                                                v-model="inventoryPercentage"
                                                :min="0"
                                                :max="100"
                                                :formatter="value => `${value}%`"
                                                :parser="value => value.replace('%', '')"
                                                @change="onChangeInventoryPercentage"
                                            />
                                            </base-input>
                                        </div>
                                        <hr>
                                        <fieldset :disabled="ProductFormStatus">
                                            <h2>Product Definition
                                                <base-dropdown class="float-right"  v-if="$attrs.action != 'View' && (inputType=='online_store' || inputType=='')" position="right">
                                                    <div class="media align-items-center" slot="title">
                                                    <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                    </div>
                                                    <template>
                                                        <div class=" dropdown-header noti-title">
                                                            <h6 class="text-overflow m-0">ACTIONS</h6>
                                                        </div>
                                                        <a-upload
                                                            :multiple="false"
                                                            :remove="handleRemove"
                                                            :fileList="fileList"
                                                            :beforeUpload="uploadProduct">
                                                            <a class="dropdown-item w-100">
                                                                <a-icon type="upload" /> 
                                                                <span>Upload CSV</span>
                                                            </a> 
                                                        </a-upload>
                                                        <a class="dropdown-item" @click.prevent="downloadTemplate('products')">
                                                            <i class="fa fa-download"></i>
                                                            <span>Download Template</span>
                                                        </a>
                                                    </template>
                                                </base-dropdown>
                                            </h2>
                                            <a-tabs defaultActiveKey="1" v-model="tabActiveKey">
                                                <a-tab-pane tab="Search" key="1">
                                                    <div class="row no-gutters">   
                                                        <div class="col-md-10 mb-3">
                                                            <b-input-group class="w-100">
                                                                <template v-slot:prepend>
                                                                    <b-dropdown :text="filterCaption" variant="outline-default">
                                                                        <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </template>
                                                                <b-form-input style="padding:5px; height: 44px;" @keydown.enter.prevent="allProductsData" v-model="searchText">{{searchText}}</b-form-input>
                                                            </b-input-group>
                                                        </div>
                                                        <div class="col-md-2 mb-3">
                                                            <template>
                                                                <button
                                                                    class="btn btn-s float-right mr-10 p-1 w-100 h-100" style="background-color: #394a5d;color: white;"
                                                                    @click.prevent="advanceFilter(true)">
                                                                    {{ toggleLabel }}</button>
                                                            </template>
                                                        </div>
                                                        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-2" style="background-color: #394a5d;color: white;">
                                                            <product-advance-filter
                                                                :currentFilter="currentFilter"
                                                                :parentParams="filterParams"
                                                                @changeParams="changeParams"
                                                                @closeFilter="closeFilter"
                                                                :key="filterKey" >
                                                            </product-advance-filter>
                                                        </div>
                                                    </div>
                                                    <div class="row" v-if="this.inputTypeStatus == 1 || this.inputTypeStatus == 2">
                                                        <div class="col-md-12">
                                                            <a-button type="primary" v-if="tabulatorAddBtnCount>0" class="btn float-right ml-1 btn-primary btn-sm" :loading="AddAllProductsLoading" @click.prevent="AddAllProducts"> Add All</a-button>
                                                            <a-button type="warning" v-if="tabulatorUndoBtnCount>0" class="btn float-right ml-1 btn-warning btn-sm" :loading="UndoAllProductsLoading" @click.prevent="UndoAllProducts"> Undo All</a-button>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div id="filterDiv">
                                                                <small>Currently Applied Filters:</small> &nbsp;
                                                                <div v-if="tags.length > 0">
                                                                    <template v-for="tag in tags">
                                                                        <a-tag :key="tag" :afterClose="() => handleClose(tag)" color="blue" closable>
                                                                        {{ tag }}
                                                                        </a-tag>
                                                                    </template>
                                                                </div>
                                                                <div v-else>
                                                                    <a-tag> No filters applied</a-tag>
                                                                </div>
                                                            </div>
                                                            <!-- <small v-if="postedProductLists.length>0">{{postedProductLists.length}} item<span v-if="postedProductLists.length >1">s</span> Selected</small> -->
                                                            <br>
                                                            <a-spin :spinning="AddAllProductsLoading || UndoAllProductsLoading || undoProductActionLoading || addProductActionLoading">
                                                                <div class="tabulator m-0" v-if="!runProduct">
                                                                    <div class="tabulator-footer border-0">
                                                                        <span class="tabulator-paginator">
                                                                            <label>Page Size</label>
                                                                            <select class="tabulator-page-size" v-model="tabulatorPaginationDetails.perPageSize" aria-label="Page Size" title="Page Size" @change="setPerPageSize(tabulatorPaginationDetails.perPageSize)">
                                                                                <option v-for="option in tabulatorPaginationDetails.perPageSizeOption" :value="option.value">{{option.label}}</option>
                                                                            </select>
                                                                            <button class="tabulator-page" type="button" role="button" aria-label="First Page" title="First Page" v-on:click="setTabulatorPage('number',1)" :disabled="tabulatorPaginationDetails.currentPage == 1">First</button>
                                                                            <button class="tabulator-page" type="button" role="button" aria-label="Prev Page" title="Prev Page" v-on:click="setTabulatorPage('prev',null)" :disabled="tabulatorPaginationDetails.currentPage == 1">Prev</button>
                                                                            <span class="tabulator-pages">
                                                                                <button  type="button" role="button" v-for="b in tabulatorPaginationDetails.buttons" v-bind:key="'tabutalor'+b.innerText" v-on:click="setTabulatorPage('number',b.dataset.page)" :class="b.className" :title="b.ariaLabel" :data-page="b.innerText">{{b.innerText}}</button>
                                                                            </span>
                                                                            <button class="tabulator-page" type="button" role="button" aria-label="Next Page" title="Next Page" v-on:click="setTabulatorPage('next',null)" :disabled="tabulatorPaginationDetails.currentPage==tabulatorPaginationDetails.pageCount" data-page="next">Next</button>
                                                                            <button class="tabulator-page" type="button" role="button" aria-label="Last Page" title="Last Page"  v-on:click="setTabulatorPage('number',tabulatorPaginationDetails.pageCount)" :disabled="tabulatorPaginationDetails.currentPage==tabulatorPaginationDetails.pageCount" data-page="last">Last</button>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div id="product-table" v-on:click="getTabulatorPaginationDetails()"></div>
                                                            </a-spin>
                                                        </div>
                                                    </div>
                                                </a-tab-pane>
                                                <a-tab-pane tab="Item list" key="2">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <b-input-group class="w-100">
                                                                <template v-slot:prepend>
                                                                    <b-dropdown :text="filterCaption" variant="outline-default">
                                                                        <b-dropdown-item @click.prevent="changeFilter('name')">Name</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('id')">Product Code</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('barcode')">Barcode</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('stock_no')">Stock No</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('reference_code')">Reference Code</b-dropdown-item>
                                                                        <b-dropdown-item @click.prevent="changeFilter('shelf_code')">Shelf Code</b-dropdown-item>
                                                                    </b-dropdown>
                                                                </template>
                                                                <b-form-input style="padding:5px; height: 44px;" @keydown.enter.prevent="getPostedProductData" v-model="searchTextItemList">{{searchTextItemList}}</b-form-input>
                                                            </b-input-group>
                                                        </div>
                                                        <div class="col-md-12 mt-3" v-if="inputType=='online_store'">
                                                            <small v-if="countPostedProduct>0 && massAssignList.length<=0">{{countPostedProduct}} item<span v-if="countPostedProduct >1">s</span> Selected</small>
                                                            <small v-if="countPostedProduct>0 && massAssignList.length>0">{{massAssignList.length}} item<span v-if="massAssignList.length >1">s</span> Selected</small>
                                                            <base-button type="default" class="btn float-right mr-0" size="sm" :disabled="massAssignLoading" @click.prevent="massAssign"><a-spin v-if="massAssignLoading" :spinning="massAssignLoading" /> Update Mass Assign</base-button>
                                                            <base-button type="default" class="btn float-right mr-0 bg-white text-dark mr-2" :disabled="collectionLoading" size="sm" @click.prevent="clearCollection"> <a-spin v-if="collectionLoading" :spinning="collectionLoading" /> Clear Collection</base-button>
                                                            <a-select v-model="chooseCollection" v-if="massAssignList.length>0" size="small" style="width: 120px; float: right !important;" class="mr-2">
                                                                <a-select-option value="">
                                                                    Catalog
                                                                </a-select-option>
                                                                <a-select-option v-for="(collection,collectionIndex) in collections" :key="collectionIndex" :value="collectionIndex">
                                                                {{collection.collection_name}}
                                                                </a-select-option>
                                                            </a-select>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="table-responsive mt-3">
                                                                <a-spin v-if="collectionLoading" />
                                                                <table class="table border rounded" v-else-if="!collectionLoading">
                                                                    <thead class="thead-light">
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Retail Price</th>
                                                                            <th>Ecom Price</th>
                                                                            <th v-if="inputType!='online_store'">Onhand Quantity</th>
                                                                            <th v-if="inputType!='online_store'">Available Quantity</th>
                                                                            <th width="140px" v-if="inputType=='online_store'">Sequence no</th>
                                                                            <th width="140px" v-if="inputType=='online_store'">Tag</th>
                                                                            <th width="140px" v-if="inputType=='online_store'">Collection</th>
                                                                            <th width="140px" v-if="$attrs.action != 'View'">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item,index) in itemListPagination.itemListPaginatedData" v-bind:key="'itemListPaginatedData'+index" v-if="item.sales_channel_product_status!='Delete'">
                                                                            <td>
                                                                                <input type="checkbox" :id="item.sales_channel_product_id || index" :value="item.sales_channel_product_id || index" v-model="massAssignList" v-if="inputType=='online_store'"/>
                                                                                {{item.name}}
                                                                            </td>
                                                                            <td>{{item.retail_price}}</td>
                                                                            <td>{{item.ecom_price}}</td>
                                                                            <td v-if="inputType!='online_store'">{{item.available_quantity || 0}}</td>
                                                                            <td v-if="inputType!='online_store'">{{item.onhand_quantity  || 0}}</td>
                                                                            <td v-if="inputType=='online_store'">{{item.sequence_no}}</td>
                                                                            <td v-if="inputType=='online_store'">{{item.tag | truncate(20, '...')}}</td>
                                                                            <td v-if="inputType=='online_store'">{{getCollectionName(item.sales_channel_product_collection_id || item.collection_index)}}</td>
                                                                            <td v-if="$attrs.action != 'View'">
                                                                                <button slot="actions" class="btn border-0 btn-sm" @click.prevent="editProduct(index)"><i class="fa fa-edit"></i></button>
                                                                                <button slot="actions" class="btn border-0 btn-sm" @click.prevent="removeProduct(index)"><i class="fa fa-times"></i></button>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="tabulator">
                                                                <div class="tabulator-footer">
                                                                    <span class="tabulator-paginator">
                                                                        <button type="button" class="tabulator-page" :disabled="itemListPagination.page == 1 ? true : false" @click="getPostedProductData(itemListPagination.page = 1)"> First </button>
                                                                        <button type="button" class="tabulator-page" :disabled="itemListPagination.page == 1 ? true : false" @click="getPostedProductData(itemListPagination.page--)"> Prev </button>
                                                                        <span class="tabulator-pages">
                                                                            <button type="button" class="tabulator-page" :class="{ active: itemListPagination.page == pageNumber ? true : false}" v-for="(pageNumber,i) in itemListPagination.pages" v-bind:key="'itemListPaginationPage'+pageNumber" @click="getPostedProductData(itemListPagination.page = pageNumber)"> {{pageNumber}} </button>
                                                                        </span>
                                                                        <button type="button" class="tabulator-page" @click="getPostedProductData(itemListPagination.page++)" :disabled="itemListPagination.page < itemListPagination.numberOfPages ? false : true"> Next </button>
                                                                        <button type="button" class="tabulator-page" @click="getPostedProductData(itemListPagination.page=itemListPagination.numberOfPages)" :disabled="itemListPagination.page == itemListPagination.numberOfPages ? true : false"> Last </button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </a-tab-pane>
                                            </a-tabs>
                                        </fieldset>
                                    </div>
                                    <div v-if="ProductFormStatus" v-bind:class="{'col-md-6': ProductFormStatus == true ? true : false}">
                                        <lazada-product-form :visible="ProductFormStatus" v-if="inputType=='lazada'" @closeProductFrom="closeProductFrom" :productIntegrationData="productIntegrationData" :LazadaAccessToken="LazadaAccessToken" @integrationAddProduct="integrationAddProduct" :actionStatus="actionStatus" :salesChannelStatus="$attrs.action" @integrationUpdateProduct="integrationUpdateProduct" :siteId="siteId" :selectedSublocationId="selectedSublocationId" :inventoryPercentage="inventoryPercentage" :salesChannelId="this.$attrs.salesChannelId" @getPostedProductData="getPostedProductData" @allProductsData="allProductsData"></lazada-product-form>
                                        <shopee-product-form :visible="ProductFormStatus" v-if="inputType=='shopee'" @closeProductFrom="closeProductFrom" :productIntegrationData="productIntegrationData" :ShopeeAccessToken="ShopeeShopId" @integrationAddProduct="integrationAddProduct" :actionStatus="actionStatus" :salesChannelStatus="$attrs.action" @integrationUpdateProduct="integrationUpdateProduct" :siteId="siteId" :selectedSublocationId="selectedSublocationId" :inventoryPercentage="inventoryPercentage" :salesChannelId="this.$attrs.salesChannelId" @getPostedProductData="getPostedProductData" @allProductsData="allProductsData"></shopee-product-form>
                                        <shopify-product-form :visible="ProductFormStatus" v-if="inputType=='shopify'" @closeProductFrom="closeProductFrom" :productIntegrationData="productIntegrationData" :ShopeeAccessToken="ShopeeShopId" @integrationAddProduct="integrationAddProduct" :actionStatus="actionStatus" :salesChannelStatus="$attrs.action" @integrationUpdateProduct="integrationUpdateProduct" :siteId="siteId" :selectedSublocationId="selectedSublocationId" :inventoryPercentage="inventoryPercentage" :salesChannelId="this.$attrs.salesChannelId" @getPostedProductData="getPostedProductData" @allProductsData="allProductsData"></shopify-product-form>
                                        <zalora-product-form :visible="ProductFormStatus" v-if="inputType == 'zalora'" @closeProductFrom="closeProductFrom" :productIntegrationData="productIntegrationData" :ZaloraAccessToken="ZaloraAccessToken" :ZaloraClientId="ZaloraClientId" :ZaloraClientSecret="ZaloraClientSecret" @integrationAddProduct="integrationAddProduct" :actionStatus="actionStatus" @integrationUpdateProduct="integrationUpdateProduct" :siteId="siteId" :selectedSublocationId="selectedSublocationId" :inventoryPercentage="inventoryPercentage" :salesChannelId="this.$attrs.salesChannelId" @getPostedProductData="getPostedProductData" @allProductsData="allProductsData"></zalora-product-form>

                                    </div>
                                </div>
                            </div>
                            <div v-show="step == 2" class="card-body">
                                <h2>Home Page Details</h2>
                                <div class="row ml-3">
                                    <div class="col-md-6">
                                        <div class="form-group has-label"><label class="form-control-label">
                                            Home Page Header
                                            <span>*</span></label>
                                            <textarea class="form-control" label="Collection Name" v-model="homePageHeader" id="exampleFormControlTextarea1" rows="3" placeholder="Enter your page header here"></textarea>
                                        </div>
                                        <div class="form-group has-label"><label class="form-control-label">
                                            Home Page Description
                                            <span>*</span></label>
                                            <textarea class="form-control" label="Collection Name" v-model="homePageDescription" id="exampleFormControlTextarea1" rows="3" placeholder="Enter your page description here"></textarea>
                                        </div>
                                        <base-input alternative="" label="Facebook Page" placeholder="" v-model="facebookPage" input-classes="form-control"/>
                                        <base-input alternative="" label="Instagram Page" placeholder="" v-model="instagramPage" input-classes="form-control"/>
                                        <div class="form-group has-label">
                                            <label class="font-weight-bold mr-3">
                                            UI Layout
                                            </label>
                                            <label for="">
                                                <a-radio-group name="radioGroup" v-model="uiLayout">
                                                    <a-radio :value="1">
                                                    Default
                                                    </a-radio>
                                                    <a-radio :value="2">
                                                    Compact
                                                    </a-radio>
                                                </a-radio-group>
                                            </label>    
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <h4>logo</h4>
                                        <div class="clearfix">
                                            <a-upload
                                                :action="uploadIcon"
                                                listType="picture-card"
                                                :fileList="fileListLogo"
                                                @preview="handlePreview"
                                                @change="handleChange"
                                                :headers="authHeaders"
                                                >
                                                <div v-if="fileListLogo.length < 1 && imageLoaded == true"> +
                                                    <div class="ant-upload-text">Upload</div>
                                                </div>
                                            </a-upload>
                                            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                                <img alt="example" style="width: 100%" :src="previewImage" />
                                            </a-modal>
                                        </div>
                                        <h4>Carousel</h4>
                                        <base-input class="mb-2" placeholder="Write title" input-classes="form-control form-control-sm" v-model="CarouselTitle" required />
                                        <div class="clearfix">
                                            <a-upload
                                            :action="uploadCarousel"
                                            list-type="picture"
                                            :file-list="fileListCarousel"
                                            @preview="handlePreviewCarousel"
                                            @change="handleChangeCarousel"
                                            :headers="authHeaders"
                                            :before-upload="beforeUpload"
                                            >
                                            <div v-if="fileListCarousel.length < 5">
                                                <a-button>
                                                    <a-icon type="upload" />
                                                    Upload
                                                </a-button>
                                            </div>
                                            </a-upload>
                                            <a-modal :visible="previewVisibleCarousel" :footer="null" @cancel="handleCancelCarousel">
                                                <div class="card-body pb-0" v-if="editCarouoselErrors.length">
                                                    <base-alert  type="danger" class="mb-0">
                                                        <b>You have the following error(s):</b>
                                                        <li v-for="error in editCarouoselErrors" :key="error">{{ error }}</li>
                                                    </base-alert>
                                                </div>
                                                <div v-if="successMessage != null">
                                                    <base-alert type="primary" dismissible>
                                                        <span class="alert-inner--text"> {{successMessage}}</span>
                                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </base-alert>
                                                </div>
                                                <img alt="example" style="width: 100%" class="mb-3" :src="previewImageCarousel" />
                                                <base-input alternative="" label="Title" placeholder="" v-model="previewImageCarouselDetails.title" input-classes="form-control"/>
                                                <a-button type="primary" class="btn btn-primary btn-sm border-sm mr-0" @click.prevent="saveCarouselCaption(previewImageCarouselDetails.index,previewImageCarouselDetails.title)">Save</a-button>
                                            </a-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-show="step == 3" class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h2 class="w-100">Settings
                                        </h2>
                                    </div>
                                </div>
                                <div v-if="inputType!='online_store'">
                                    <base-input label="Order Syncing Options" input-classes="form-control">
                                    <!-- <strong class="mr-3">Order Syncing Options</strong> -->
                                        <div class="row">
                                            <div class="col-md-6">
                                                <a-select style="width: 100%" v-model="orderSyncing" @change="changeOrderSyncing">
                                                    <a-select-option v-for="option in orderSyncingOptions" :key="option.value">{{option.label}}</a-select-option>
                                                </a-select>
                                            </div>
                                            <div class="col-md-6"></div>
                                        </div>
                                    </base-input>
                                    <base-input label="Order Invoice Options" input-classes="form-control">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <a-select style="width: 100%" v-model="orderInvoice" @change="changeOrderInvoice">
                                                    <a-select-option v-for="option in orderInvoiceOptions" :key="option.value">{{option.label}}</a-select-option>
                                                </a-select>
                                            </div>
                                            <div class="col-md-6"></div>
                                        </div>
                                    </base-input>
                                </div>
                                <div v-if="inputType=='online_store'">
                                    <div class="row">
                                        <a-tabs class="col-md-12" type="card" default-active-key="1" @change="onChangeSettingsTab">
                                            <a-tab-pane key="1" tab="Shipping">
                                                <div class="row ml-3">
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowDelivery" @change="onChangeAllowDelivery">
                                                                <strong>Allow Delivery</strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the Shipping list of your
                                                                    online store to accept "Delivery" Method</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div v-if="AllowDelivery">
                                                            <strong class="mr-3">Shipping Fee</strong>
                                                            <label for="">
                                                                <a-radio-group name="radioGroup" v-model="shippingFee">
                                                                    <a-radio :value="1">
                                                                    Fixed Fee
                                                                    </a-radio>
                                                                    <a-radio :value="2">
                                                                    Price Range
                                                                    </a-radio>
                                                                </a-radio-group>
                                                            </label>
                                                            <br>
                                                            <div class="form-row">
                                                                <base-input class="col mb-0" v-if="shippingFee == 2" placeholder="Write Amount" v-model="shippingFeeAmount" input-classes="form-control form-control-sm" required />
                                                                <base-input class="col mb-0" placeholder="Write shipping Fee" v-model="shippingFeeFixValue" input-classes="form-control form-control-sm" required />
                                                            </div>
                                                            <label v-if="shippingFee == 2">
                                                                For every <Strong>{{shippingFeeAmount}}</Strong>, Shipping fee is <strong>{{shippingFeeFixValue}}</strong>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6"></div>
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowStorePickup" @change="onChangeAllowStorePickup">
                                                                <strong>Allow Store Pickup</strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the Shipping list on your
                                                                    online store to accept "Store Pickup" Method</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </a-tab-pane>
                                            <a-tab-pane key="2" tab="Payment">
                                                <div class="row ml-3">
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowCOD" :disabled="!AllowDelivery" @change="onChangeAllowCOD">
                                                                <strong>Allow COD </strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the payment list of your online 
                                                                    store to accept "Cash on Delivery" Method</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowCOP" :disabled="!AllowStorePickup" @change="onChangeAllowCOP">
                                                                <strong>Allow COP </strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the payment list of your online 
                                                                    store to accept "Cash on Pickup" Method</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowIpay88" @change="onChangeAllowIpay88">
                                                                <strong>Allow Ipay88 </strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the payment list of your online 
                                                                store to accept "Ipay88" Method</span>
                                                                <base-input label="select supported payment types"  v-if="AllowIpay88" input-classes="form-control">
                                                                    <a-select mode="multiple" v-model="salesChannelpaymentMethods" style="width: 100%">
                                                                        <a-select-option v-for="paymentMethod in ipay88PaymentMethods" :key="paymentMethod.payment_id" :value="paymentMethod.payment_id">
                                                                            {{paymentMethod.payment_name}}
                                                                        </a-select-option>
                                                                    </a-select>
                                                                </base-input>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3"></div>
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowPaymaya" @change="onChangeAllowPaymaya">
                                                                <strong>Allow Paymaya </strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the payment list of your online 
                                                                    store to accept "Paymaya" Method</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowDragonpay" @change="onChangeAllowDragonpay">
                                                                <strong>Allow Dragonpay</strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an option on the payment list of your online 
                                                                    store to accept "Dragonpay" Method</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </a-tab-pane>
                                            <a-tab-pane key="3" tab="Stores">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <base-input label="Default Site" input-classes="form-control">
                                                            <a-select v-model="siteId" class="mr-2" @change="getAllSubLocation">
                                                                <a-select-option v-for="(site,siteIndex) in defaultSitesList" :key="siteIndex" :value="site.id">
                                                                {{site.name}}
                                                                </a-select-option>
                                                            </a-select>
                                                        </base-input>
                                                        <base-input label="Sublocation" input-classes="form-control">
                                                            <a-select v-model="selectedSublocationId" class="mr-2">
                                                                <a-select-option v-for="(sub,subIndex) in sublocationList" :key="subIndex" :value="sub.id">
                                                                {{sub.name}}
                                                                </a-select-option>
                                                            </a-select>
                                                        </base-input>
                                                        <base-input label="Supported Store" input-classes="form-control">
                                                            <br>
                                                            <small v-if="supportedSiteList.length>0">{{supportedSiteList.length}} Selected store<span v-if="supportedSiteList.length >1">s</span></small>
                                                            <div id="branches-table"></div>
                                                        </base-input>
                                                    </div>
                                                </div>
                                            </a-tab-pane>
                                            <a-tab-pane key="4" tab="Others">
                                                <div class="row ml-3">
                                                    <div class="col-md-3">
                                                        <label>
                                                            <a-checkbox :checked="AllowAddToCart" @change="onChangeAllowAddToCart">
                                                                <strong>Allow Add To Cart </strong>
                                                            </a-checkbox>
                                                            <br/>
                                                            <div class="pl-4">
                                                                <span>This adds an Ability to Add To Cart from the Product List<br>
                                                                    view (and not necessarily from the Product Page)</span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3"></div>
                                                </div>
                                            </a-tab-pane>
                                        </a-tabs>
                                    </div>
                                    <hr>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h2 class="w-100">Domain Setup
                                            </h2>
                                        </div>
                                    </div>
                                    <div class="row ml-3">
                                        <div class="col-md-6">
                                            <base-input alternative placeholder="sample.bxi.com" label="Domain Name" v-model="domainName" input-classes="form-control"/>
                                            <div class="row mb-4">
                                                <div class="col-md-12">
                                                    <base-button type="primary" class="btn float-right mr-0" v-if="editDomainIndex == null && domains.length < 5" @click.prevent="addDomain">Add
                                                    </base-button> 
                                                    <base-button type="default" class="btn float-right mr-2 bg-white text-dark" v-if="editDomainIndex != null" @click.prevent="updateDomain"> Update
                                                    </base-button>
                                                </div>
                                            </div>                              
                                            <a-list size="small"
                                                class="demo-loadmore-list border custom-scrollbar-css" style="max-height:15rem;overflow-x:hidden;"
                                                :loading="loading"
                                                item-layout="horizontal"
                                                :data-source="domains"
                                            >
                                                <a-list-item slot="renderItem" slot-scope="item, index" v-if="item.domain_status!='Delete'">
                                                    <base-dropdown class="nav-link pr-0 float-right" slot="actions" v-if="$attrs.action != 'View'" position="right">
                                                        <div class="media align-items-center" slot="title">
                                                            <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
                                                        </div>
                                                        <template>
                                                            <div class=" dropdown-header noti-title">
                                                                <h6 class="text-overflow m-0">ACTIONS</h6>
                                                            </div>
                                                            <a :id="index" class="dropdown-item" @click.prevent="EditDomain(index)">
                                                                <i class="fa fa-edit"></i>
                                                                <span>Edit Domain</span>
                                                            </a>
                                                            <a :id="index" class="dropdown-item" @click="removeDomain(index)">
                                                                <i class="fa fa-trash"></i>
                                                                <span>Delete Domain</span>
                                                            </a>
                                                        </template>
                                                    </base-dropdown>
                                                    <a-list-item-meta>
                                                        <a slot="title"  href="" class="ml-3">{{ item.domain_name }}</a>
                                                    </a-list-item-meta>
                                                    <div>{{item.status}}</div>
                                                </a-list-item>
                                                <div slot="header" class="pl-2 text-uppercase">
                                                    Domains
                                                </div>
                                            </a-list>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </form>
                    </div>
                </a-spin>
            </div>
        </div>
    </fieldset>
    <div v-if="this.$attrs.viewMode != true">
        <div v-if="spinning == false" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <a-button type="primary" size="large" v-if="(this.$attrs.action == 'Create'|| this.$attrs.action == 'resume_create') && ((step == 3 && inputType=='online_store') || (inputType!='online_store' && step==3))" :loading="createLoading" class="btn float-right mr-0 btn-primary" @click.prevent="create">Create
            </a-button>
            <a-button type="primary" size="large" v-else-if="(this.$attrs.action == 'Edit')" class="btn btn-primary float-right" :loading="updateLoading" @click.prevent="update">Update
            </a-button>
            <button v-if="step != 3" type="button" class="btn btn-primary float-right ant-btn-lg mr-3" @click.prevent="nextStep(step+1,'next')">Next</button> 
            <button v-if="step != 0" type="button" class="btn float-right bg-white ant-btn-lg text-dark mr-3" @click.prevent="nextStep(step-1,'back')">Back</button> 
        </div>
        <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <button type="button" class="btn btn-primary float-right ant-btn-lg" @click.prevent="$emit('closeDrawer', null)">Close</button> 
        </div>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import LazadaProductForm from '../../views/Sales Channel/LazadaProductForm.vue'
    import ProductAdvanceFilter from "../Products/ProductAdvanceFilter.vue"
    import ShopeeProductForm from '../../views/Sales Channel/ShopeeProductForm.vue'
    import ShopifyProductForm from '../../views/Sales Channel/ShopifyProductForm.vue'
    import ZaloraProductForm from "../../views/Sales Channel/ZaloraProductForm.vue"
    import OnlineStoreProductForm from '../../views/Sales Channel/OnlineStoreProductForm.vue'
    import { mapState } from 'vuex'
    import Tabulator from 'tabulator-tables'

    var table,table1;
    var component_x;
    export default {
        components: {
            LazadaProductForm,
            ShopeeProductForm,
            ShopifyProductForm,
            ZaloraProductForm,
            OnlineStoreProductForm,
            ProductAdvanceFilter
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType','publicUrl','updateParentId', 'updateParameters']),
            
        },
        mounted: async function () {
            component_x = this
            if (this.$attrs.salesChannelId > 0){
                this.spinning = true;
                var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channels/' + this.$attrs.salesChannelId, null)
                var sales_channel_data = response["sales_channel"]
                if(sales_channel_data == undefined){
                    component_x.$router.go()
                } else {
                    if(sales_channel_data["error"] == undefined){
                        component_x.id = sales_channel_data["id"]
                        component_x.inputName = sales_channel_data["name"]
                        component_x.inputType = sales_channel_data["sales_channel_type"]
                        if (sales_channel_data["sales_channel_type"] == 'online_store'){
                            component_x.inputTypeStatus = 1
                        } else if (sales_channel_data["sales_channel_type"] == 'shopify'){
                            component_x.inputTypeStatus = 2 
                            component_x.ShopifyAccessToken = sales_channel_data["access_token"]
                            component_x.ShopifyAccessTokenStatus = sales_channel_data["connection_status"] == "C" ? true : false
                        }else if (sales_channel_data["sales_channel_type"] == 'shopee'){
                            component_x.inputTypeStatus = 3
                            component_x.ShopeeShopId = sales_channel_data["shop_id"]
                            component_x.ShopeeAccessToken = sales_channel_data["access_token"]
                            component_x.ShopeeRefreshToken = sales_channel_data["refresh_token"]
                            component_x.ShopeeShopIdStatus = sales_channel_data["connection_status"] == "C" ? true : false
                        }else if (sales_channel_data["sales_channel_type"] == "lazada"){
                            component_x.LazadaAccessToken = sales_channel_data["access_token"]
                            component_x.LazadaRefreshToken = sales_channel_data["refresh_token"]
                            component_x.LazadaCode = sales_channel_data["access_token"]
                            component_x.LazadaCodeStatus = sales_channel_data["connection_status"] == "C" ? true : false
                            component_x.inputTypeStatus = 4
                        } else if (sales_channel_data["sales_channel_type"] == "zalora") {
                            component_x.ZaloraClientId = sales_channel_data["shop_id"];
                            component_x.ZaloraClientSecret = sales_channel_data["refresh_token"];
                            component_x.ZaloraAccessToken = sales_channel_data["access_token"];
                            component_x.ZaloraClientIdStatus =
                            sales_channel_data["connection_status"] == "C" ? true : false;
                            component_x.ZaloraClientSecretStatus =
                            sales_channel_data["connection_status"] == "C" ? true : false;
                            component_x.inputTypeStatus = 5;
                        }else{}
                        component_x.theme_id = sales_channel_data["theme_id"]
                        component_x.homePageHeader = sales_channel_data["page_header"]
                        component_x.homePageDescription = sales_channel_data["page_description"]
                        component_x.facebookPage = sales_channel_data["facebook_url"]
                        component_x.instagramPage = sales_channel_data["instagram_url"]
                        component_x.collections = response["collections"]
                        component_x.AllowCOD = sales_channel_data["is_cod"]
                        component_x.AllowStorePickup = sales_channel_data["is_store_pickup"]
                        component_x.AllowCOP = sales_channel_data["is_cop"]
                        component_x.AllowDragonpay = sales_channel_data["is_dragonpay"]
                        component_x.AllowPaymaya = sales_channel_data["is_paymaya"]
                        component_x.AllowIpay88 = sales_channel_data["is_ipay88"]
                        component_x.AllowDelivery = sales_channel_data["is_delivery"]
                        component_x.AllowAddToCart = sales_channel_data["is_allow_add_to_cart"]
                        component_x.shippingFee = sales_channel_data["shipping_fee_option"]==null ? 1 : sales_channel_data["shipping_fee_option"]
                        component_x.shippingFeeAmount = sales_channel_data["shipping_fee_amount"]
                        component_x.shippingFeeFixValue = sales_channel_data["shipping_fee"]
                        component_x.domains = response["domains"]
                        component_x.uiLayout = sales_channel_data["ui_layout"]
                        component_x.siteId = sales_channel_data["site_id"]
                        component_x.salesChannelpaymentMethods = sales_channel_data["ipay88_payment_methods"]
                        component_x.supportedSiteList = response["stores"]
                        component_x.inventoryPercentage = sales_channel_data["inventory_percentage"]
                        component_x.selectedSublocationId = sales_channel_data["sublocation_id"]
                        component_x.orderSyncing = sales_channel_data["order_syncing"]
                        component_x.orderInvoice = sales_channel_data["order_invoice"]
                        if (sales_channel_data["icon_name"] != null) {
                            component_x.fileListLogo = [{
                                uid: sales_channel_data['id'],
                                name: sales_channel_data["icon_name"],
                                status: 'done',
                                url: component_x.publicUrl + 'online_store_images/' + sales_channel_data["icon_name"]
                            }]
                        } else {
                            component_x.fileListLogo = []
                        }
                        if (sales_channel_data["carousel"] != null) {
                            component_x.fileListCarousel = sales_channel_data["carousel"]
                        }else {
                            component_x.fileListCarousel =[]
                        }
                        component_x.spinning = false;
                    } else {
                        this.errors = sales_channel_data["error"].split(",");
                    } 
                }
            }
            this.getallSites()
            this.$attrs.action=="Create" || this.$attrs.action=="resume_create" ? this.siteId = secureStorage.getItem("defaultSiteId") : ''
            this.getAllSubLocation()
            if(this.$attrs.action!="Create" && this.$attrs.salesChannelId !=undefined){
                this.getPostedProductData()
            }else if(this.$attrs.action=="resume_create" && this.$attrs.salesChannelId==undefined){
                this.AuthorizeRedirectLoading = true
                this.inputName = secureStorage.getItem("inputName")
                this.inputType = secureStorage.getItem("inputType")
                this.inputTypeStatus = secureStorage.getItem("inputTypeStatus")
                var c = this.$route.query
                switch (c["marketplace"]) {
                    case "shopee":
                        if(c["code"]!=undefined){
                            var response = await HTTPRequest.postRequest(this.endPoint + 'marketplace_integrations/shopee_authentication',null, {code:c["code"],shop_id:c["shop_id"]})
                            if (response["error"] == undefined || response["error"] == "") {
                                this.ShopeeShopId = c["shop_id"]
                                this.ShopeeAccessToken = response["access_token"]
                                this.ShopeeRefreshToken = response["refresh_token"]
                                component_x.ShopeeShopIdStatus = true
                                secureStorage.removeItem("inputName")
                                secureStorage.removeItem("inputType")
                                secureStorage.removeItem("inputTypeStatus")
                                window.history.pushState({}, null, window.location.origin+"/online_stores")
                                this.AuthorizeRedirectLoading = false
                            } else {
                                secureStorage.removeItem("inputName")
                                secureStorage.removeItem("inputType")
                                secureStorage.removeItem("inputTypeStatus")
                                this.errors = response["error"].split(",")
                                window.history.pushState({}, null, window.location.origin+"/online_stores")
                                this.AuthorizeRedirectLoading = false
                            }
                        }
                    break;
                    case "lazada":
                        if (c["code"]!=undefined){
                            var response = await HTTPRequest.postRequest(component_x.endPoint+ 'marketplace_integrations/lazada_authentication', null, {code:c["code"]})
                            if (response["error"] == undefined){
                                this.LazadaAccessToken = response["access_token"]
                                this.LazadaRefreshToken = response["refresh_token"]
                                this.LazadaCode = response["access_token"]
                                this.LazadaCodeStatus = true
                                secureStorage.removeItem("inputName")
                                secureStorage.removeItem("inputType")
                                secureStorage.removeItem("inputTypeStatus")
                                window.history.pushState({}, null, window.location.origin+"/online_stores")
                                this.AuthorizeRedirectLoading = false
                            }else{
                                secureStorage.removeItem("inputName")
                                secureStorage.removeItem("inputType")
                                secureStorage.removeItem("inputTypeStatus")
                                this.errors = response["error"].split(",")
                                window.history.pushState({}, null, window.location.origin+"/online_stores")
                                this.AuthorizeRedirectLoading = false
                            }
                        }
                    break;
                    default:
                        if (c["shop"] == this.inputName+".myshopify.com"){
                            var code = c["code"]
                            var hmac = c["hmac"]
                            var shop = c["shop"]
                            var timestamp = c["timestamp"]
                            var authparams = {
                                code:code,
                                hmac:hmac,
                                shop:shop,
                                timestamp:timestamp,
                            }
                            if(code!=undefined && hmac!=undefined && shop!=undefined && timestamp!=undefined){
                                var response = await HTTPRequest.postRequest(component_x.endPoint + 'marketplace_integrations/shopify_authentication', null, authparams)
                                if (response["error"] == undefined){
                                    this.ShopifyAccessToken = response["access_token"]
                                    this.ShopifyAccessTokenStatus = true
                                    secureStorage.removeItem("inputName")
                                    secureStorage.removeItem("inputType")
                                    secureStorage.removeItem("inputTypeStatus")
                                    window.history.pushState({}, null, window.location.origin+"/online_stores")
                                    this.AuthorizeRedirectLoading = false
                                }else{
                                    secureStorage.removeItem("inputName")
                                    secureStorage.removeItem("inputType")
                                    secureStorage.removeItem("inputTypeStatus")
                                    this.errors = response["error"].split(",")
                                    window.history.pushState({}, null, window.location.origin+"/online_stores")
                                    this.AuthorizeRedirectLoading = false
                                }
                            }
                        }else{
                            this.AuthorizeRedirectLoading = false
                        }
                    break;
                }
            }
            await this.checkPercentage()
            this.formSettings = this.$attrs.formSettings
            await this.allProductsData()
        },
        data() {
            return {
                radioStyle: {
                    display: 'block',
                    lineHeight: '30px',
                },
                spinning:false,
                step:0,
                id:"",
                form: "",
                inputName: '',
                inputTypeStatus: '',
                inputType: '',
                theme_id:'',
                errors:[],
                postedProductLists:[],
                selectedProduct:null,
                loading: false,
                loadingMore: true,
                showLoadingMore: true,
                editCollectionIndex:null,
                collectionLoading:false,
                collectionName:'',
                collectionDesc:'',
                collectionID:'',
                collections:[],
                homePageHeader:'',
                homePageDescription:'',
                facebookPage:'',
                instagramPage:'',
                siteId:'',
                searchText:'',
                searchTextItemList:'',
                filterCaption: "Search by Name",
                filterField: "name",
                tabActiveKey:"1",
                options: {
                    layout:"fitDataStretch",
                    ajaxURL:'',
                    ajaxConfig:{
                        method:"GET", 
                        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                    },
                    pagination:"remote",
                    paginationSizeSelector: [10,20,30,40],
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    paginationSize:10,
                    columns:[
                        {title: 'Name', field: "name", width:200, headerSort:false},
                        {title: 'Stock No.', field: "stock_no", width:140, headerSort:false},
                        {title: 'Retail Price', field: 'retail_price',width:100, headerSort:false},
                        {title: '',align:'center',formatter: this.addButton,cellClick: this.selectProductAction,headerSort: false},
                    ]
                },
                options1: {
                    layout:"fitDataStretch",
                    ajaxURL:'',
                    ajaxConfig:{
                        method:"GET", 
                        headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
                    },
                    pagination:"remote",
                    paginationDataSent:{
                        "page":"page",
                        "size":"per_page"
                    },
                    showData:[],
                    paginationSize:10,
                    columns:[
                        {title: 'ID', field: "id", headerSort:false},
                        {title: 'Name', field: "name", width:300, headerSort:false},
                        {title: '',align:'center',formatter: this.addSiteButton,cellClick: this.selectSiteAction,headerSort: false},
                    ],
                },
                fileList: [],
                runProduct:false,
                runSite:false,
                headers: {
                    authorization: 'authorization-text',
                },
                sample:null,
                ShopeeShopId:null,
                ShopeeShopIdStatus:false,
                ShopeeAccessToken:null,
                ShopeeRefreshToken:null,
                ShopifyAccessToken:null,
                ShopifyAccessTokenStatus:false,
                LazadaCode:null,
                LazadaCodeStatus:false,
                LazadaAccessToken:null,
                LazadaRefreshToken:null,
                ZaloraClientId: null,
                ZaloraClientIdStatus: false,
                ZaloraClientSecret: null,
                ZaloraClientSecretStatus: false,
                ZaloraAccessToken: null,
                ZaloraAccessTokenStatus: false,
                AuthorizeLoading:false,
                AuthorizeRedirectLoading:false,
                createLoading:false,
                updateLoading:false,
                AllowCOD:null,
                AllowStorePickup:null,
                AllowCOP:null,
                AllowIpay88:null,
                AllowDragonpay:null,
                AllowPaymaya:null,
                AllowDelivery:null,
                AllowAddToCart:null,
                editDomainIndex:null,
                domainLoading:false,
                domainName:'',
                domains:[],
                ProductFormStatus:false,
                productIntegrationData:{},
                actionStatus:null,
                shippingFee:null,
                shippingFeeAmount:null,
                shippingFeeFixValue:null,
                uiLayout:1,
                fileListLogo: [],
                fileListCarousel:[],
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") },
                previewVisibleCarousel: false,
                previewImageCarousel: '',
                previewImageCarouselDetails:{},
                previewVisible: false,
                previewImage: '',
                imageLoaded: true,
                CarouselTitle:null,
                fileListCarouselUploadStatus:true,
                massAssignList:[],
                chooseCollection:null,
                editCarouoselErrors:[],
                successMessage:null,
                defaultSitesList:[],
                supportedSiteList:[],
                ipay88PaymentMethods:[
                    {payment_name:"Credit Card (PHP)",payment_id:1},
                    {payment_name:"GCash",payment_id:3},
                    {payment_name:"Bancnet",payment_id:5},
                    {payment_name:"Paypal (PHP)",payment_id:6},
                    {payment_name:"Credit Card (USD)",payment_id:7},
                    {payment_name:"DragonPay Online",payment_id:18},
                    {payment_name:"DragonPay OTC Non-Bank",payment_id:19},
                    {payment_name:"DragonPay OTC Bank",payment_id:20},
                    {payment_name:"Pay4Me",payment_id:22},
                    {payment_name:"Credit Card Pre-Auth (PHP)",payment_id:25},
                    {payment_name:"WeChat Scan",payment_id:33},
                    {payment_name:"WeChat QR",payment_id:34},
                    {payment_name:"Alipay QR",payment_id:35},
                    {payment_name:"Alipay Scan",payment_id:36},
                    {payment_name:"BDO Installment",payment_id:37},
                    {payment_name:"GrabPay",payment_id:38},
                    {payment_name:"7/11",payment_id:48},
                ],
                salesChannelpaymentMethods:[],
                sublocationList:[],
                selectedSublocationId:null,
                inventoryPercentage:0,
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                currentFilter: "categories",
                placeholder: this.currentFilter,
                filterParams: {},
                filterKey: 0,
                parentParams: {},
                tags:[],
                advanceFilterParamsToString:"",
                setTable:false,
                itemListPagination:{
                    page: 1,
                    perPage: 10,
                    pages: [],
                    itemListPaginatedData:[]
                },
                countPostedProduct:0,
                tabulatorCurrentPage:0,
                tabulatorUndoBtnCount:0,
                tabulatorAddBtnCount:0,
                orderSyncingOptions: [
                    { label: 'Default - Create posted SO and pending DD document', value: 'D' },
                    { label: 'Manual - Only create pending SO document', value: 'M' },
                ],
                orderInvoiceOptions: [
                    { label: 'Default - Invoice through posted SI document', value: 'M' },
                    { label: 'Wavelet - Invoice through POS document printing', value: 'P' },
                ],
                orderSyncing:'D',
                orderInvoice:'M',
                tabulatorPaginationDetails:{
                    pageCount:0,
                    currentPage:1,
                    buttons:[],
                    perPageSizeOption:[],
                    perPageSize:10
                },
                formSettings:[],
                totalPercentage:0,
                zaloraUserId:null,
                zaloraAccessToken:null,
                UndoAllProductsLoading:false,
                AddAllProductsLoading:false,
                massAssignLoading:false,
                collectionLoading:false,
                updateCollectionLoading:false,
                removeCollectionLoading:false,
                addCollectionLoading:false,
                undoProductActionLoading:false,
                addProductActionLoading:false,
                removeProductLoading:false,
            };
        },
        watch:{
            AllowDelivery: function () {
                if(!this.AllowDelivery){
                    this.AllowCOD = false
                    this.shippingFee = null
                    this.shippingFeeAmount = null
                    this.shippingFeeFixValue = null
                }else {
                    this.shippingFee = this.shippingFee!=null ? this.shippingFee : 1
                    this.shippingFeeAmount = this.shippingFeeAmount!=null ? this.shippingFeeAmount : null
                    this.shippingFeeFixValue = this.shippingFeeFixValue!=null ? this.shippingFeeFixValue : null
                }
            },
            AllowStorePickup: function() {
                if(!this.AllowStorePickup){
                   this.AllowCOP = false
                }
            },
            step: function(){
                this.runSite = true;
                this.step == 1 ? this.allProductsData() : ""
            },
            tabActiveKey: function(){
                this.tabActiveKey == "2" ? this.getPostedProductData() : ""
            },
            currentFilter: async function(){
                if (this.currentFilter == "suppliers") {
                var suppliers = await HTTPRequest.getRequest(this.endPoint + "/suppliers" , null)
                this.sort(suppliers.data);
                this.setParentId(0);
                } else if (this.currentFilter == "brands") {
                var brands = await HTTPRequest.getRequest(this.endPoint + "/brands" , null)
                this.sort(brands.data);
                this.setParentId(0);
                }
            },
        },
        methods: {
            getPostedProductData:async function(){
                if (this.$attrs.action=="Create"|| this.$attrs.action=="resume_create"){
                    this.updatePostedData()
                }else{
                    this.loading = true
                    var search = (this.searchTextItemList!=null && this.searchTextItemList !="") ? "&search="+this.searchTextItemList+"&field_name="+this.filterField : ""
                    var pagination_params = "?page="+this.itemListPagination.page+"&per_page="+this.itemListPagination.perPage+search
                    var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channels/get_posted_products'+pagination_params+'&id='+this.id  , null)
                    this.postedProductLists = response.data
                    let numberOfPages = response.last_page
                    this.itemListPagination.itemListPaginatedData = response.data
                    this.itemListPagination.numberOfPages = numberOfPages
                    if (this.itemListPagination.page > numberOfPages){
                        this.itemListPagination.page = numberOfPages || 1
                        this.itemListPagination.pages = [1]
                    }
                    for (let index = 1; index <= numberOfPages; index++) {
                        this.itemListPagination.pages.push(index);
                    }
                    let numShown = 10;   // This sets the number of page tabs
                    numShown = Math.min(numShown, numberOfPages);
                    let first = this.itemListPagination.page - Math.floor(numShown / 2);
                    first = Math.max(first, 1);
                    first = Math.min(first, numberOfPages - numShown + 1);
                    this.itemListPagination.pages = [...Array(numShown)].map((k,i) => i + first);
                    this.loading = false
                }
            },
            sort(data){
                data = data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
                });
                this.data = data;
            },
            setParentId(id){
                this.updateParentId(id);
                if(this.currentFilter == 'brands'){
                this.updateParameters("?brand_id=" + this.parentId);
                } else if (this.currentFilter == 'suppliers'){
                this.updateParameters("?supplier_id=" + this.parentId);
                }
            },
            async removeProduct(index){
                this.removeProductLoading = true
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    var postedIndex = this.postedProductLists.findIndex(x=> x.id == index)
                    this.postedProductLists.splice(postedIndex,1)
                }else{
                    var product = []
                    product.push(this.postedProductLists[index])
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channels/mass_delete_products', null, {id:this.id,sales_channel_products:product}) 
                     if (post_request["error"] == undefined){
                        this.$notification['success']({
                            message: 'Successful Operation',
                        });
                    }else{
                        this.errors = post_request["error"].split(",")
                    }
                    this.getPostedProductData()
                }
                this.allProductsData();
                this.removeProductLoading = false
            },
            selectProductAction: function(e, cell){
                if(e.target.id!=""){
                    this.asyncSelectProductAction(e.target.id,e.target.name,cell.getRow().getData())
                    console.log(e)
                    console.log(cell)
                }
            },
            async asyncSelectProductAction(id,name,data){
                this.errors =[]
                switch (name) {
                    case "Add":
                        if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                            var postedIndex = this.postedProductLists.findIndex(x=> x.id == id)
                        }
                        if(this.inputTypeStatus != 1 && this.inputTypeStatus !=2 ){
                            if(!this.inventoryValidation()){
                                this.ProductFormStatus = true
                                this.productIntegrationData = data
                            }
                        }else{
                            if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                                this.addProduct(data,postedIndex)
                            }else{
                                this.addProductAction(data)
                            }
                        }
                    break;
                    case "Undo":
                        if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                            var postedIndex = this.postedProductLists.findIndex(x=> x.id == id)
                            this.postedProductLists.splice(postedIndex,1)
                        }else{
                            this.undoProductAction(data)
                        }
                    break;
                    default:
                    break;
                }
                table.redraw(true);
                (this.$attrs.action=="Create" || this.$attrs.action=="resume_create") ? this.updatePostedData() : ""
            },
            async addProductAction(data){
                this.addProductActionLoading = true
                var product = []
                product.push(data)
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channels/mass_add_products', null, {id:this.id,sales_channel_products:product}) 
                 if (post_request["error"] == undefined){
                    this.$notification['success']({
                        message: 'Successful Operation',
                    });
                }else{
                    this.errors = post_request["error"].split(",")
                }
                this.allProductsData()
                table.redraw(true);
                this.addProductActionLoading = false
            },
            async undoProductAction(data){
                this.undoProductActionLoading = true
                var product = []
                product.push(data)
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channels/mass_delete_products', null, {id:this.id,sales_channel_products:product}) 
                 if (post_request["error"] == undefined){
                    this.$notification['success']({
                        message: 'Successful Operation',
                    });
                }else{
                    this.errors = post_request["error"].split(",")
                }
                this.allProductsData()
                table.redraw(true);
                this.undoProductActionLoading = false
            },
            addProduct(data,postedIndex){
                if (postedIndex <0){
                    data.tag = null
                    data.collection_index = -1
                    data.sales_channel_product_status = 'New'
                    data.sequence_no = this.postedProductLists.length+1
                    this.postedProductLists.push(data)
                }else if(postedIndex>=0 && this.postedProductLists[postedIndex].sales_channel_product_status == 'Delete'){
                    this.postedProductLists[postedIndex].sales_channel_product_status = ''
                }else {
                    this.errors.push("Product " +this.postedProductLists[postedIndex].name + " is already exist")
                }
            },
            infoValidation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Name', this.inputName));
                this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
                this.errors.push(ValidateField.required('Type', this.inputTypeStatus));
                this.errors.push(ValidateField.alphanumericWithSpecialChars('type', this.inputTypeStatus));
                this.errors.push(ValidateField.charMinAndMax('type', this.inputTypeStatus, 0, 50));
                if (this.inputTypeStatus==2){
                    this.errors.push(ValidateField.required('Shopify access token', this.ShopifyAccessToken));
                    this.errors.push(ValidateField.validateBoolean('Shopify Access Token', this.ShopifyAccessTokenStatus));
                }else if (this.inputTypeStatus==3){
                    this.errors.push(ValidateField.required('Shopee Id', this.ShopeeShopId));
                    this.errors.push(ValidateField.validateBoolean('Shopee Id', this.ShopeeShopIdStatus));
                }else if (this.inputTypeStatus==4){
                    this.errors.push(ValidateField.required('Lazada Code', this.LazadaCode));
                    this.errors.push(ValidateField.validateBoolean('Lazada Code', this.LazadaCodeStatus));
                }else if (this.inputTypeStatus == 5) {
                    this.errors.push(ValidateField.required("Zalora Secret", this.ZaloraClientSecret));
                    this.errors.push(ValidateField.validateBoolean("Zalora Secret", this.ZaloraClientSecretStatus));this.errors.push(ValidateField.required("Zalora Client Id", this.ZaloraClientId));
                    this.errors.push(ValidateField.validateBoolean("Zalora Client Id", this.ZaloraClientIdStatus));
                }
                if((this.$attrs.action != "View" || this.inputType!='online_store') && this.selectedSublocationId!=null){
                    if (this.formSettings.is_enable_allocation_validation == true){
                        switch (true) {
                            case (this.totalPercentage > 100):
                                this.errors.push("100% of sublocation is already allocated to other sales channel")
                            break;
                            case (this.totalPercentage < 100):
                                var ttl = this.totalPercentage + this.inventoryPercentage
                                if (ttl > 100){
                                    this.errors.push(`Inventory Percentage should not exceed to available percentage which is ${100 - this.totalPercentage}%`)
                                    // this.errors.push(`the available percentage for the selected sublocation is ${100 - response["total_percentage"]}`)
                                }
                            break;
                            default:
                            break;
                        }
                    }
                }
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            async checkPercentage(){
                if((this.$attrs.action != "View" || this.inputType!='online_store') && this.selectedSublocationId!=null){
                    var params = (this.$attrs.action!="Create" && this.$attrs.salesChannelId !=undefined) ? '&sales_channel_id=' + this.$attrs.salesChannelId : ''
                    var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channels/get_total_percentage?sublocation_id=' + this.selectedSublocationId+'&site_id='+this.siteId + params, null)
                    if (response["error"] == undefined) {
                        this.totalPercentage = response["total_percentage"] || 0
                    }else{
                        this.errors.push(response["error"])
                    }
                }
            },
            CustomizationValidation(){
                this.errors = [];
                if (this.inputType == 'online_store'){
                    this.errors.push(ValidateField.required('Home Page Header', this.homePageHeader));
                    this.errors.push(ValidateField.alphanumericWithSpecialChars('Home Page Header', this.homePageHeader));
                    this.errors.push(ValidateField.charMinAndMax('Home Page Header', this.homePageHeader, 0, 50));
                    this.errors.push(ValidateField.required('Home Page Description', this.homePageDescription));
                    this.errors.push(ValidateField.alphanumericWithSpecialChars('Home Page Description', this.homePageDescription));
                    this.errors.push(ValidateField.charMinAndMax('Home Page Description', this.homePageDescription, 0, 150));
                }
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            nextStep: function(value,status){
                switch (value) {
                    case 0:
                        this.step = value;
                    break;
                    case 1:
                        if(!this.infoValidation()) {
                            this.inputTypeStatus == 1 ? this.inputType = 'online_store' : this.inputTypeStatus == 2 ? this.inputType = 'shopify' : this.inputTypeStatus == 3 ? this.inputType = 'shopee' : this.inputTypeStatus == 4 ? this.inputType = 'lazada' : this.inputTypeStatus == 5 ? this.inputType = "zalora" : ''
                            this.step = value;
                            this.runProduct = true;
                        }else{
                            this.step = value-1;
                        }
                    break;
                    case 2:
                        if(!this.inventoryValidation()){
                            if(this.inputType!='online_store'){
                                if (status=="next"){
                                    this.step = value+1;
                                }else{
                                    this.step = value-1;
                                }
                            }else {
                                this.step = value;
                            }
                        }else{
                            this.step = value-1;
                        }
                        
                    break;
                    case 3:
                        if(!this.CustomizationValidation()){
                            this.step = value;
                            this.runSite = true;
                            this.getallSites()
                        }else{
                            this.step = value-1;
                        }
                    break;
                    default:
                    break;
                }
            },
            collectionValidation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Collection Name', this.collectionName));
                this.errors.push(ValidateField.required('Collection Description', this.collectionDesc));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            async addCollection(){
                if(!this.collectionValidation()){
                    this.addCollectionLoading = true
                    if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                        var postedIndex = this.collections.findIndex(x=> x.collection_name == this.collectionName)
                        if (postedIndex<0){
                            this.collections.push({collection_name:this.collectionName,collection_description:this.collectionDesc})
                            this.collectionName = null
                            this.collectionDesc = null
                        }else {
                            this.errors.push("Collection " +this.collections[postedIndex].collection_name + " is already exist")
                        }
                    }else {
                        var payload = {
                            collection_name:this.collectionName,
                            collection_description:this.collectionDesc
                        }
                        var response = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channel_products/add_collection', null,{sales_channel_id:this.id,sales_channel_collection:payload})
                        if (response["error"] == undefined){
                            this.$notification['success']({
                                message: 'Success',
                                description: "Successfully added."
                            });
                            this.getAllCollection()
                        }else{
                            this.errors = response["error"].split(",")
                        }
                    }
                    this.addCollectionLoading = false
                }
            },
            EditCollection(index){
                if (index!=null){
                    this.editCollectionIndex = index;
                    this.collectionName = this.collections[index].collection_name;
                    this.collectionDesc = this.collections[index].collection_description;
                    this.collectionID = this.collections[index].id;
                }
            },
            clearCollectionFields(){
                this.editCollectionIndex = null;
                this.collectionName = null;
                this.collectionDesc = null;
                this.collectionID = null;
            },
            async getAllCollection(){
                var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/get_all_collections?sales_channel_id=' + this.id, null)
                this.collections = response
            },
            async removeCollection(index){
                this.removeCollectionLoading = true
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    this.collections.splice(index,1)
                    var item = this.postedProductLists.filter(item => item.collection_index == index); 
                    for (let ind = 0; ind < item.length; ind++) {
                        var value = this.postedProductLists.findIndex(x=> x.id == item[ind].id)
                        if (value > -1){
                            this.postedProductLists[value].collection_index = -1
                        }
                    }
                }else{
                    var response = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channel_products/remove_collection', null,{id:this.collections[index].id})
                    if (response["error"] == undefined){
                        this.$notification['success']({
                            message: 'Success',
                            description: "Successfully Removed."
                        });
                        this.getAllCollection()
                    }else{
                        this.errors = response["error"].split(",")
                    }
                }
                this.removeCollectionLoading = false
            },
            async updateCollection(){
                this.updateCollectionLoading = true
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    this.collections[this.editCollectionIndex].collection_name = this.collectionName;
                    this.collections[this.editCollectionIndex].collection_description = this.collectionDesc;
                    this.clearCollectionFields()
                }else{
                    var payload = {
                        collection_name:this.collectionName,
                        collection_description:this.collectionDesc
                    }
                    var response = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channel_products/update_collection', null,{id:this.collectionID,sales_channel_collection:payload})
                    if (response["error"] == undefined){
                        this.$notification['success']({
                            message: 'Success',
                            description: "Successfully Updated."
                        });
                        this.getAllCollection()
                        this.clearCollectionFields()
                    }else{
                        this.errors = response["error"].split(",")
                    }
                }
                this.updateCollectionLoading = false
            },
            allProductsData: async function(){
                var search = (this.searchText!=null && this.searchText !="") ? "&"+this.filterField+'='+this.searchText : ""
                search += (this.siteId>0)? "&site_id="+this.siteId : ""
                this.$attrs.action == "Edit" ? search+="&sales_channel_id="+this.id+"" : ""
                try {
                    table.options.ajaxURL = this.endPoint + 'products?type=sales_channel'+ search + this.advanceFilterParamsToString
                } catch (error) {
                    this.options.ajaxURL = this.endPoint + 'products?type=sales_channel'+ search + this.advanceFilterParamsToString
                }
                if (this.setTable){
                    this.options = table.options
                    this.options.paginationSize = table.modules.page.size || 10
                    var current_page = table.modules.page.page || 1
                    this.options.paginationInitialPage = current_page
                    this.getTabulatorPaginationDetails()
                }
                table = await new Tabulator("#product-table", this.options);
                if (this.setTable){
                    await table.setMaxPage(current_page);
                }
                this.setTable = true
                this.runProduct = false
            },
            addButton (cell, formatterParams){
                let id = cell.getRow().getData().id
                var button = ""
                var postedIndex = -1
                if (this.tabulatorCurrentPage != table.modules.page.page){
                    this.tabulatorCurrentPage = table.modules.page.page || 0
                    this.tabulatorUndoBtnCount = 0
                    this.tabulatorAddBtnCount = 0
                }
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    postedIndex = this.postedProductLists.findIndex(x=> x.id == id)
                }else{
                    var sales_channel_product_id = cell.getRow().getData().sales_channel_product_id
                    postedIndex = sales_channel_product_id != null && sales_channel_product_id > 0 ? sales_channel_product_id : -1
                }
                if (postedIndex <0){
                    this.tabulatorAddBtnCount += 1
                    button += '<button id="' + id + '" name="Add" class="btn btn-success btn-sm">Add</button>'
                }else{
                    this.tabulatorUndoBtnCount += 1
                    button += '<button id="' + id + '" name="Undo" class="btn btn-sm btn-warning">Undo</button>'
                }
                return button
            },
            changeFilter(value){
                this.filterField = value
                this.filterCaption = "Filter By " + _.startCase(this.filterField)
            },
            clearCollection: async function(){
                this.collectionLoading = true;
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    if (this.postedProductLists.length > 1){
                        for (let index = 0; index < this.postedProductLists.length; index++) {
                            this.postedProductLists[index].collection_index = -1;
                        }
                    }
                }else{
                    var result = this.postedProductLists.map(function(a) {return a.sales_channel_product_id;});
                    var response = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channels/clear_collection', null,{id:this.id,sales_channel_product_ids:result})
                    if (response["error"] == undefined){
                        this.$notification['success']({
                            message: 'Success',
                            description: "Successfully cleared."
                        });
                        this.getAllCollection()
                    }else{
                        this.errors = response["error"].split(",")
                    }
                }
                await this.getPostedProductData()
                this.collectionLoading = false;
            },
            downloadTemplate(name){
                var urlDownload = this.endPoint + "sales_channels/download_file?name="+name
                axios({
                    url:  urlDownload,
                    method: 'POST',
                    responseType: 'blob', // important
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
                    }
                    }).then((response) => {
                    
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name+'_import_template.csv');
                    document.body.appendChild(link);
                    link.click();
                    component_x.$notification['success']({
                        message: 'Successful Download',
                        description: "You have succesfully downloaded the template for product upload."
                    });
                });
            },
            uploadCollection(file) {
                this.fileList = [...this.fileList, file];
                this.fileList = this.fileList.slice(-1);
                var searchCSV = this.fileList[0].type.search("csv")
                if (searchCSV>=0){
                    let promise = new Promise((resolve, reject) => {
                        var reader = new FileReader();
                        var vm = this;
                        reader.onload = (e) => {
                            resolve((vm.sample = vm.parseCollectionCSV(reader.result, '\n', ',')));
                        }
                        reader.readAsText(vm.fileList[0]);
                    });
                    promise.then(
                        result => {
                        console.log(this.sample);
                        },
                        error => {
                        console.log(error);
                        }
                    );
                }else{
                    this.$notification['error']({
                        message: 'File Error',
                        description: "File type is not supported"
                    });
                    this.fileList = []
                }
                return false;
            },
            parseCollectionCSV(text, lineTerminator, cellTerminator) {
                var lines = text.split(lineTerminator);
                var checkCount = 0;
                for(var j = 0; j<lines.length; j++){
                    if(lines[j] != ""){
                        var information = lines[j].split(cellTerminator);
                        if (j!=0){
                            var collectionIndex = this.collections.findIndex(x=> x.collection_name == information[0])
                            if (collectionIndex<0){
                                this.collections.push({collection_name:information[0],collection_description:information[1]})
                                this.$attrs.action == "Edit" ? this.collections[this.collections.length-1].collection_status = "New" : ""
                            }else if(collectionIndex>=0 && this.collections[collectionIndex].collection_status == "Delete"){
                                this.collections[collectionIndex].collection_status = ""
                            }else {
                                this.errors.push("Collection " +this.collections[collectionIndex].collection_name + " is already exist")
                                checkCount ++;
                            }
                            if (j+1==(lines.length-1)){
                                this.fileList = []
                                if (checkCount+1 == (lines.length-1)){
                                    this.$notification['error']({
                                        message: 'Operation failed',
                                        description: "",
                                    });
                                }else{
                                    this.$notification['success']({
                                        message: 'Successful Operation',
                                        description: "File has been uploaded.",
                                    });
                                }
                            }
                        }else if (j==0){
                            if (information[0] == "collection_name" && information[1]=="collection_description"){
                            }else{
                                this.$notification['error']({
                                    message: 'Operation failed',
                                    description: "invalid Template",
                                });
                                break;
                            }
                        }
                    }
                }
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            uploadProduct(file) {
                this.fileList = [...this.fileList, file];
                this.fileList = this.fileList.slice(-1);
                var searchCSV = this.fileList[0].type.search("csv")
                if (searchCSV>=0){
                    let promise = new Promise((resolve, reject) => {
                        var reader = new FileReader();
                        var vm = this;
                        reader.onload = (e) => {
                            resolve((vm.sample = vm.parseProductCSV(reader.result, '\n', ',')));
                        }
                        reader.readAsText(vm.fileList[0]);
                    });
                    promise.then(
                        result => {
                        console.log(this.sample);
                        },
                        error => {
                        console.log(error);
                        }
                    );
                }else{
                    this.$notification['error']({
                        message: 'File Error',
                        description: "File type is not supported"
                    });
                    this.fileList = []
                }
                return false;
            },
            parseProductCSV(text, lineTerminator, cellTerminator) {
                var lines = text.split(lineTerminator);
                var checkCount = 0;
                for(var j = 0; j<lines.length; j++){
                    if(lines[j] != ""){
                        var information = lines[j].split(cellTerminator);
                        if (j!=0){
                            axios({
                                method: 'GET',
                                url: this.endPoint +'sales_channels/check_product?name=' + information[0] + '&barcode=' + information[1] + '&stock_no='+ information[2] + '&tag=' + information[3] + '&collection=' + information[4],
                                headers: {
                                    Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                                    "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
                                },
                            })
                            .then(function (response) {
                                if (response.data !=null){
                                    var postedIndex = component_x.postedProductLists.findIndex(x=> x.id == response.data.id)
                                    if (component_x.$attrs.action == 'Create'){
                                        var postedIndex = component_x.postedProductLists.findIndex(x=> x.id == response.data.id)
                                    }else{
                                        var postedIndex = component_x.postedProductLists.findIndex(x=> x.product_id == response.data.id)
                                    }
                                    if (postedIndex <0){
                                        response.data.tag = response.data.tag.replace("-",",")
                                        var searchCollection = component_x.collections.findIndex(x=> x.collection_name == response.data.collection)
                                        if (searchCollection>=0){
                                            response.data.collection_index = searchCollection
                                        }else {
                                            response.data.collection_index = -1
                                        }
                                        component_x.$attrs.action == "Edit" ? response.data.sales_channel_product_status = "New" : ""
                                        component_x.postedProductLists.push(response.data)
                                    }else if(postedIndex>=0 && component_x.postedProductLists[postedIndex].sales_channel_product_status == "Delete"){
                                        component_x.postedProductLists[postedIndex].sales_channel_product_status = ""
                                    }else {
                                        component_x.errors.push("Product " +component_x.postedProductLists[postedIndex].name + " is already exist")
                                        checkCount++;
                                    }
                                    component_x.allProductsData()
                                }
                            })
                            if (j+1==(lines.length-1)){
                                component_x.fileList = []
                                if (checkCount+1 == (lines.length-1)){
                                    component_x.$notification['error']({
                                        message: 'Operation failed',
                                        description: "",
                                    });
                                }else{
                                    component_x.$notification['success']({
                                        message: 'Successful Operation',
                                        description: "File has been uploaded.",
                                    });
                                }
                            }
                        }else if(j==0){
                            if (information[0] == "name" && information[1]=="barcode" && information[2] =="stock_no" && information[3]=="tag(-)" && information[4]=="collection"){
                            }else{
                                this.$notification['error']({
                                    message: 'Operation failed',
                                    description: "invalid Template",
                                });
                                break;
                            }
                        }
                    }
                }
            },
            marketplaceAuthorization: async function(key){
                if (this.inputName!=null && this.inputName!=''){
                    this.AuthorizeLoading = true
                    switch (key) {
                        case 2:
                            var response = await HTTPRequest.postRequest(this.endPoint + 'marketplace_integrations/shopify_keys', null,{redirect_url:"http://"+window.location.host+""+window.location.pathname})
                            if (response == undefined) {
                                this.$emit('refreshPage', event)
                            } else {
                                if (response["error"] == undefined) {
                                    secureStorage.setItem("inputName",this.inputName)
                                    secureStorage.setItem("inputType",this.inputType)
                                    secureStorage.setItem("inputTypeStatus",this.inputTypeStatus)
                                    var scope = "write_orders,write_products,write_inventory,write_price_rules,write_discounts,write_reports,write_checkouts,read_analytics,write_shipping";
                                    window.location.href = 'https://' + this.inputName + '.myshopify.com/admin/oauth/authorize?client_id=' + response.appkey + '&scope=' + scope + '&redirect_uri=' + response.redirect_url;
                                } else {
                                    this.errors = response["error"].split(",")
                                }
                                this.AuthorizeLoading = false
                            }
                        break;
                        case 3:
                            var response = await HTTPRequest.postRequest(this.endPoint + 'marketplace_integrations/shopee_keys', null, {redirect_url:"https://"+window.location.host+""+window.location.pathname})
                            if (response == undefined) {
                                this.$emit('refreshPage', event)
                            } else {
                                if (response["error"] == undefined) {
                                    secureStorage.setItem("inputName",this.inputName)
                                    secureStorage.setItem("inputType",this.inputType)
                                    secureStorage.setItem("inputTypeStatus",this.inputTypeStatus)
                                    window.location.href = response.shopee_url+'/shop/auth_partner?partner_id=' + response.SHOPEE_ID  + '&redirect=' + response.redirect_url +'&timestamp='+ response.timestamp + '&sign=' + response.sign;
                                } else {
                                    this.errors = response["error"].split(",")
                                }
                                this.AuthorizeLoading = false
                            }
                        break;
                        case 4:
                            var response = await HTTPRequest.postRequest(this.endPoint + 'marketplace_integrations/lazada_keys', null, {redirect_url:"https://"+window.location.host+""+window.location.pathname})
                            if (response == undefined) {
                                this.$emit('refreshPage', event)
                            } else {
                                if (response["error"] == undefined) {
                                    secureStorage.setItem("inputName",this.inputName)
                                    secureStorage.setItem("inputType",this.inputType)
                                    secureStorage.setItem("inputTypeStatus",this.inputTypeStatus)
                                    window.location.href = response.lazada_url+'?client_id='+response.client_id+'&force_auth='+response.force_auth+'&redirect_uri='+response.redirect_url+'&response_type='+response.response_type;
                                } else {
                                    this.errors = response["error"].split(",")
                                }
                                this.AuthorizeLoading = false
                            }
                        break;
                        case 5:
                            var response = await HTTPRequest.getRequest(
                            this.endPoint +
                                "marketplace_integrations/zalora_authorize_cred?client_secret=" +
                                this.ZaloraClientSecret +
                                "&client_id=" +
                                this.ZaloraClientId,
                            null
                            );
                            
                            if (response == undefined) {
                            this.$emit("refreshPage", event);
                            } else {
                                if (response["error"] == undefined) {   
                                    console.log(response) 
                                    this.ZaloraAccessToken = response["body"]["access_token"];
                                    this.ZaloraClientId = response["client_id"];
                                    this.ZaloraClientSecret = response["client_secret"];
                                    // secureStorage.setItem("client_id", this.ZaloraClientId);
                                    // secureStorage.setItem("client_secret", this.ZaloraClientSecret);
                                    secureStorage.setItem("inputName", this.inputName);
                                    secureStorage.setItem("inputType", this.inputType);
                                    secureStorage.setItem("inputTypeStatus", this.inputTypeStatus);
                                    this.ZaloraClientSecretStatus = true;
                                    this.ZaloraClientIdStatus = true;
                                } else {
                                    console.log(response)
                                    this.errors = response["error"].split(",");
                                }
                            this.AuthorizeLoading = false;
                            }
                        break;
                        default:
                        break;
                    }
                }else{
                    this.errors = [];
                    this.errors.push(ValidateField.required('Name', this.inputName));
                    this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
                    this.errors = this._.compact(this.errors);
                }
            },
            getQueryParams(qs) {
                var vars = {};
                var parts = qs.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                    vars[key] = value;
                });
                return vars;
            },
            emptyField: function (newVal) {
                this.LazadaAccessToken = null
                this.LazadaRefreshToken = null
                this.LazadaCode = null
                this.LazadaCodeStatus = false
                this.ShopeeShopId = null
                this.ShopeeShopIdStatus = false
                this.ShopifyAccessToken = null
                this.ShopifyAccessTokenStatus = false
                // this. ZaloraAccessToken = null
                // this. ZaloraAccessTokenStatus = false
                // this.ZaloraUserId = null
                // this.ZaloraUserIdStatus = false
            },
            addDomainValidation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Domain Name', this.domainName));
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            addDomain: async function(){
                if(!this.addDomainValidation()){
                    var postedIndex = this.domains.findIndex(x=> x.domain_name == this.domainName)
                    if (postedIndex<0){
                        var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channels/validate_domain?domain_name=' + this.domainName, null)
                        if(!response.status){
                            this.domains.push({domain_name:this.domainName,status:"A"})
                            this.$attrs.action == "Edit" ? this.domains[this.domains.length-1].domain_status = "New" : ""
                            this.domainName = null
                        }else{
                            this.errors = []
                            this.errors.push("Domain "+this.domainName+" is connected to other sales channel");
                        }
                    }else if(postedIndex>=0 && this.domains[postedIndex].domain_status == "Delete"){
                        this.domains[postedIndex].domain_status = ""
                    }else {
                        this.errors = []
                        this.errors.push("Domain " +this.domains[postedIndex].domain_name + " is already exist")
                    }
                }
            },
            EditDomain(index){
                if (index!=null){
                    this.editDomainIndex = index;
                    this.domainName = this.domains[index].domain_name;
                }
            },
            removeDomain(index){
                if (this.$attrs.action == "Edit" && this.domains[index].domain_status != "New"){
                    this.domains[index].domain_status = "Delete"
                    this.domains.push(this.domains[index])
                    this.domains.splice(index,1)
                }else{
                    this.domains.splice(index,1)
                }
            },
            updateDomain(){
                this.domains[this.editDomainIndex].domain_name = this.domainName;
                this.editDomainIndex = null;
                this.domainName = null;
            },
            domainAndMarketplaceValidation(){
                this.errors = [];
                if (this.inputTypeStatus==1){
                    this.errors.push(ValidateField.greaterThanZero('domains', this.domains.length, 'Add atleast one domain'));
                    this.errors.push(ValidateField.greaterThanZero('postedProductLists', this.postedProductLists.length, 'Add atleast one product'));
                    this.errors.push(ValidateField.required('Default Site', this.siteId));
                    this.errors.push(ValidateField.required('Sublocation', this.selectedSublocationId));
                }
                if (this.AllowDelivery){
                    if(this.shippingFee == 1){
                        this.errors.push(ValidateField.requiredButAllowZero('Shipping fee', this.shippingFeeFixValue));
                    }else if(this.shippingFee == 2){
                        this.errors.push(ValidateField.requiredButAllowZero('Shipping fee', this.shippingFeeFixValue));
                        this.errors.push(ValidateField.requiredButAllowZero('Amount', this.shippingFeeFixValue));
                    }
                }
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            create: async function () {
                if(!this.domainAndMarketplaceValidation()){
                    this.createLoading = true
                    if (this.siteId == null || this.siteId == ''){
                        this.siteId = secureStorage.getItem("defaultSiteId")
                    }
                    let file = null;
                    if(this.fileListLogo.length > 0){
                        if (this.fileListLogo[0].response == undefined){
                            file = this.fileListLogo[0].name
                        } else {
                            file = this.fileListLogo[0].response
                        }
                    }
                    var SalesChannelPayload = {
                        sales_channel: {
                            name: this.inputName.trim(), 
                            sales_channel_type: this.inputType.trim(),
                            status: 'A',
                            collections:this.collections,
                            page_header:this.homePageHeader,
                            page_description:this.homePageDescription,
                            facebook_url:this.facebookPage,
                            instagram_url:this.instagramPage,
                            sales_channel_products:this.postedProductLists,
                            shop_id:this.inputTypeStatus == 3 ? this.ShopeeShopId : this.inputTypeStatus == 5 ? this.ZaloraClientId : null,
                            access_token:this.inputTypeStatus == 1 ? null : this.inputTypeStatus == 2 ? this.ShopifyAccessToken : this.inputTypeStatus == 3 ? this.ShopeeAccessToken : this.inputTypeStatus == 4 ? this.LazadaAccessToken : this.inputTypeStatus == 5 ? this.ZaloraAccessToken : '',
                            refresh_token:this.inputTypeStatus == 4 ? this.LazadaRefreshToken : this.inputTypeStatus == 3 ? this.ShopeeRefreshToken  : this.inputTypeStatus == 5 ? this.ZaloraClientSecret : null,
                            connection_status:"C",
                            is_cod:this.AllowCOD,
                            is_store_pickup:this.AllowStorePickup,
                            is_cop:this.AllowCOP,
                            is_delivery:this.AllowDelivery,
                            is_dragonpay:this.AllowDragonpay,
                            is_ipay88:this.AllowIpay88,
                            is_paymaya:this.AllowPaymaya,
                            is_allow_add_to_cart:this.AllowAddToCart,
                            domains:this.domains,
                            shipping_fee_option:this.shippingFee,
                            shipping_fee:this.shippingFeeFixValue,
                            shipping_fee_amount:this.shippingFeeAmount,
                            ui_layout:this.uiLayout,
                            carousel:this.fileListCarousel,
                            icon_name:file,
                            site_id:this.siteId,
                            sales_channel_stores:this.supportedSiteList,
                            ipay88_payment_methods:this.salesChannelpaymentMethods,
                            inventory_percentage:this.inventoryPercentage,
                            sublocation_id:this.selectedSublocationId,
                            order_syncing:this.orderSyncing,
                            order_invoice:this.orderInvoice
                        },
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channels', null, SalesChannelPayload)    
                    if (post_request == undefined) {
                        this.createLoading = false
                        this.$notification['error']({
                            message: 'Failed',
                            description: "Please check your inputs."
                        });
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            if (this.$attrs.action == "resume_create"){
                                window.history.pushState({}, null, window.location.origin+"/online_stores");
                            }
                            this.$notification['success']({
                                message: 'Success',
                                description: "sales channel successfully created."
                            });
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                        this.createLoading = false
                    }
                }
            },
            update: async function () {
                if(!this.domainAndMarketplaceValidation() && !this.infoValidation()){
                    this.updateLoading = true
                    if (this.siteId == null || this.siteId == ''){
                        this.siteId = secureStorage.getItem("defaultSiteId")
                    }
                    let file = null;
                    if(this.fileListLogo.length > 0){
                        if (this.fileListLogo[0].response == undefined){
                            file = this.fileListLogo[0].name
                        } else {
                            file = this.fileListLogo[0].response
                        }
                    }
                    var SalesChannelPayload = {
                        sales_channel: {
                            name: this.inputName.trim(),
                            sales_channel_type: this.inputType.trim(),
                            status: 'A',
                            collections:this.collections,
                            page_header:this.homePageHeader,
                            page_description:this.homePageDescription,
                            facebook_url:this.facebookPage,
                            instagram_url:this.instagramPage,
                            sales_channel_products:this.postedProductLists,
                            shop_id:this.inputTypeStatus == 3 ? this.ShopeeShopId : this.inputTypeStatus == 5 ? this.ZaloraClientId : null,
                            access_token:this.inputTypeStatus == 1 ? null : this.inputTypeStatus == 2 ? this.ShopifyAccessToken : this.inputTypeStatus == 3 ? this.ShopeeAccessToken : this.inputTypeStatus == 4 ? this.LazadaAccessToken : this.inputTypeStatus == 5 ? this.ZaloraAccessToken : '',
                            refresh_token:this.inputTypeStatus == 4 ? this.LazadaRefreshToken : this.inputTypeStatus == 3 ? this.ShopeeRefreshToken  : this.inputTypeStatus == 5 ? this.ZaloraClientSecret : null,
                            connection_status:"C",
                            is_cod:this.AllowCOD,
                            is_store_pickup:this.AllowStorePickup,
                            is_cop:this.AllowCOP,
                            is_delivery:this.AllowDelivery,
                            is_ipay88:this.AllowIpay88,
                            is_dragonpay:this.AllowDragonpay,
                            is_paymaya:this.AllowPaymaya,
                            is_allow_add_to_cart:this.AllowAddToCart,
                            domains:this.domains,
                            shipping_fee_option:this.shippingFee,
                            shipping_fee:this.shippingFeeFixValue,
                            shipping_fee_amount:this.shippingFeeAmount,
                            ui_layout:this.uiLayout,
                            carousel:this.fileListCarousel,
                            icon_name:file,
                            site_id:this.siteId,
                            sales_channel_stores:this.supportedSiteList,
                            ipay88_payment_methods:this.salesChannelpaymentMethods,
                            inventory_percentage:this.inventoryPercentage,
                            sublocation_id:this.selectedSublocationId,
                            order_syncing:this.orderSyncing,
                            order_invoice:this.orderInvoice
                        },
                    }   
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channels/' + this.id, null, SalesChannelPayload)
                    if (put_request == undefined) {
                        this.updateLoading = false
                        this.$notification['error']({
                            message: 'Failed',
                            description: "Please check your inputs."
                        });
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$notification['success']({
                                message: 'Success',
                                description: "sales channel successfully updated."
                            });
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                        this.updateLoading = false
                    }
                }
            },
            closeProductFrom(){
                this.ProductFormStatus = false
            },
            integrationAddProduct(data){
                if (this.$attrs.action == 'Create' || this.$attrs.action=="resume_create"){
                    var postedIndex = this.postedProductLists.findIndex(x=> x.id == data.id)
                    this.addProduct(data,postedIndex)
                    this.updatePostedData()
                }
                this.closeProductFrom()
                this.allProductsData()
            },
            editProduct: async function(index){
                var productData = this.itemListPagination.itemListPaginatedData[index]
                if (this.$attrs.action == "Edit"){
                    switch (this.inputType) {
                        case "lazada":
                            var response = await HTTPRequest.postRequest(component_x.endPoint + 'lazada_integrations/get_product', null,{access_token:this.LazadaCode,external_id:productData.external_id})
                            if (response["error"] == undefined){
                                var arr = {
                                    PrimaryCategory:productData.category_cascader[productData.category_cascader.length-1],
                                    Attributes:response["attributes"],
                                    Skus:[],
                                    SellerSku:null,
                                    quantity:null,
                                    price:null,
                                    package_length:response["skus"][0]["package_length"],
                                    package_height:response["skus"][0]["package_height"],
                                    package_weight:response["skus"][0]["package_weight"],
                                    package_width:response["skus"][0]["package_width"],
                                    cascader_category:productData.category_cascader,
                                }
                                if (productData.product_type == "M"){
                                    response["skus"].forEach((value, index) => {
                                        var skuTemplate = {
                                            SkuId:value.SkuId,
                                            SellerSku:value.SellerSku,
                                            quantity:value.Available,
                                            price:value.price,
                                        }
                                        if (value.size!=null){
                                            skuTemplate.size = value.size
                                        }
                                        if (value.color_family!=null){
                                            skuTemplate.color_family = value.color_family
                                        }
                                        arr.Skus.push(skuTemplate)
                                    })
                                } else {
                                    arr.price = response["skus"][0]["price"]
                                    arr.SkuId = response["skus"][0]["SkuId"]
                                    arr.quantity = response["skus"][0]["Available"]
                                    arr.SellerSku = response["skus"][0]["SellerSku"]
                                    if (response["skus"][0]["color_family"]!=null){
                                        arr.Attributes.color_family = response["skus"][0]["color_family"]
                                    }
                                } 
                                productData.lazadaParams = arr
                            }else if(response["error"] != undefined){
                                this.$confirm({
                                    title: 'This Item does not exist on the seller center',
                                    content: h => <div>Do you want to delete this product on item list? </div>,
                                    okText: 'Yes',
                                    cancelText: 'No',
                                    onOk: () => {
                                        this.removeItemProduct(productData.id)
                                    },
                                    onCancel() {
                                    }
                                });
                            }
                        break;
                        case "zalora":
                        var response = await HTTPRequest.postRequest(
                            component_x.endPoint + "zalora_integrations/get_product",
                            null,
                            {
                                access_token: this.ZaloraAccessToken,
                                external_id: productData.external_id,
                            }
                            );
                            var get_price = await HTTPRequest.postRequest(
                            component_x.endPoint + "zalora_integrations/get_price",
                            null,
                            { access_token: this.ZaloraAccessToken, price: response["id"] }
                            );
                            if (response["error"] == undefined) {
                            var arr = {
                                PrimaryCategory:
                                productData.category_cascader[productData.category_cascader.length - 1],
                                Attributes: {
                                name: productData.name,
                                short_description: null,
                                description: null,
                                brandId: null,
                                ...response["attributes"],
                                },
                                Skus: [],
                                SellerSku: null,
                                quantity: null,
                                price: null,
                                box_height_config: 1,
                                weight_config: 1,
                                cascader_category: productData.category_cascader,
                            };
                            if (productData.product_type == "M") {
                                var productset_product = await HTTPRequest.postRequest(
                                component_x.endPoint + "zalora_integrations/get_productset_product",
                                null,
                                {
                                    access_token: this.ZaloraAccessToken,
                                    external_id: productData.external_id,
                                }
                                );
                                console.log(productset_product)
                                productset_product.forEach((value, index) => {
                                var skuTemplate = {
                                    SellerSku: value.sellerSku,
                                };
                                if (value.variation != null) {
                                    skuTemplate.size = value.variation;
                                }
                                arr.price = get_price["price"];
                                arr.Attributes.brandId = response["brandId"];
                                arr.Attributes.short_description = response["attributes"]["88"];
                                arr.Attributes.description = response["description"];
                                arr.Attributes["60"] = response["attributes"]["60"][0];
                                arr.Skus.push(skuTemplate);
                                });
                            } else {
                                
                                arr.price = get_price["price"];
                                arr.SellerSku = response["sellerSku"];
                                arr.Attributes.short_description = response["attributes"]["88"];
                                arr.Attributes.description = response["description"];
                                arr.Attributes.brandId = response["brandId"];
                                arr.Attributes["60"] = response["attributes"]["60"][0];
                            }
                            productData.zaloraParams = arr;
                            } else if (response["error"] != undefined) {
                            this.$confirm({
                                title: "This Item does not exist on the seller center",
                                content: (h) => (
                                <div>Do you want to delete this product on item list? </div>
                                ),
                                okText: "Yes",
                                cancelText: "No",
                                onOk: () => {
                                this.removeItemProduct(productData.id);
                                },
                                onCancel() {},
                            });
                            }
                        break;
                        case "shopee":
                            var response = await HTTPRequest.postRequest(component_x.endPoint + 'shopee_integrations/get_product', null,{access_token:this.ShopeeShopId,external_id:productData.external_id})
                            if (response["error"] == undefined){
                                var arr = {
                                    category_id:null,
                                    attributes:response["attributes"],
                                    attribute_values:{},
                                    tier_variation:response["tier_variation"],
                                    variation:[],
                                    temp_variation:[],
                                    logistics:[],
                                    tempLogistics:[],
                                    is_2tier_item:response["is_2tier_item"],
                                    name:response["name"],
                                    description:response["description"],
                                    package_length:response["package_length"],
                                    package_height:response["package_height"],
                                    weight:response["weight"],
                                    package_width:response["package_width"],
                                    cascader_category:productData.category_cascader,
                                }
                                response["attributes"].forEach((value, index) => {
                                    arr.attribute_values[`${value.attribute_id}`] = value.attribute_value
                                })
                                response["logistics"].forEach((value, index) => {
                                    if (value.size_id == null || value.size_id == '' || value.size_id == undefined) {
                                        arr.tempLogistics.push({ logistic_id: value.logistic_id,logistic_name:value.logistic_name, enabled: true })
                                        arr.logistics.push({ logistic_id: value.logistic_id, enabled: true })
                                    } else {
                                        arr.tempLogistics.push({ logistic_id: value.logistic_id,logistic_name:value.logistic_name, enabled: true, size_id: Number(value.size_id) })
                                        arr.logistics.push({ logistic_id: value.logistic_id, enabled: true, size_id: Number(value.size_id) })
                                    }
                                })
                                if (productData.product_type == "M"){
                                    response["variations"].forEach((value, index) => {
                                        var options = value.name.split(",")
                                        arr.variation.push({variation_id:value.variation_id,stock:value.stock,price:parseFloat(value.price),variation_sku:value.variation_sku})
                                        if (options.length == 1){
                                            arr.temp_variation.push({option:options[0],stock:value.stock,price:parseFloat(value.price),variation_sku:value.variation_sku})
                                        }else if(options.length == 2){
                                            arr.temp_variation.push({option:options[0],option1:options[1],stock:value.stock,price:parseFloat(value.price),variation_sku:value.variation_sku})
                                        }
                                    })
                                } else {
                                    arr.price = response["price"]
                                    arr.stock = response["stock"]
                                    arr.item_sku = response["item_sku"]
                                }
                                productData.shopeeParams = arr
                            }else if(response["error"] != undefined){
                                this.$confirm({
                                    title: 'This Item does not exist on the seller center',
                                    content: h => <div>Do you want to delete this product on item list? </div>,
                                    okText: 'Yes',
                                    cancelText: 'No',
                                    onOk: () => {
                                        this.removeItemProduct(productData.id)
                                    },
                                    onCancel() {
                                    }
                                });
                            }
                        break;
                        case "shopify":
                            var response = await HTTPRequest.postRequest(component_x.endPoint + 'shopify_integrations/get_product', null,{id:this.id,external_id:productData.external_id})
                            if (response["error"] == undefined){
                                var arr = {
                                    title:response.title,
                                    body_html:response.body_html,
                                    inventory_quantity:0,
                                    sku:null,
                                    price:null,
                                    barcode:null,
                                    options:response.options,
                                    variants:response.variants,
                                }
                                if (productData.product_type == "M"){
                                    //
                                } else {
                                    arr.price = response["variants"][0]["price"]
                                    arr.sku = response["variants"][0]["sku"]
                                    arr.inventory_quantity = response["variants"][0]["inventory_quantity"]
                                    arr.barcode = response["variants"][0]["barcode"]
                                    arr.weight = response["variants"][0]["weight"]
                                } 
                                productData.shopifyParams = arr
                            }else if(response["error"] != undefined){
                                this.$confirm({
                                    title: 'This Item does not exist on the seller center',
                                    content: h => <div>Do you want to delete this product on item list? </div>,
                                    okText: 'Yes',
                                    cancelText: 'No',
                                    onOk: () => {
                                        this.removeItemProduct(productData.id)
                                    },
                                    onCancel() {
                                    }
                                });
                            }
                        break;
                        case "online_store":
                            productData.collections = this.collections
                            var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/get_product?id='+productData.sales_channel_product_id+"&sales_channel_id="+this.id+"&product_type="+productData.product_type+'&product_id='+productData.id, null)
                            productData.onlineStoreProductDetails = response
                        break;
                        default:
                        break;
                    }
                    if (response["error"] == undefined){
                        this.ProductFormStatus = true
                        this.productIntegrationData = productData
                        this.actionStatus = "Edit"
                    }
                }else{
                    if (this.inputType == "online_store"){
                        productData.collections = this.collections
                        if(productData.children==undefined || productData.children == null){
                            var response = await HTTPRequest.getRequest(component_x.endPoint + 'sales_channel_products/get_product?&product_type='+productData.product_type+'&product_id='+productData.id, null)
                            productData.children = response
                        }
                    }
                    this.ProductFormStatus = true
                    this.productIntegrationData = productData
                    this.actionStatus = "Edit"
                }
            },
            integrationUpdateProduct(data){
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    var postedIndex = this.postedProductLists.findIndex(x=> x.id == data.id)
                }else{
                    var postedIndex = this.postedProductLists.findIndex(x=> x.product_id == data.id)
                    if (postedIndex<0){
                        var postedIndex = this.postedProductLists.findIndex(x=> x.id == data.id)
                    }
                }
                this.updateProduct(data,postedIndex)
                this.closeProductFrom()
                this.allProductsData()
            },
            updateProduct(data,postedIndex){
                if (postedIndex <0){
                    data.collection_index = -1
                    this.$attrs.action == "Edit" ? data.sales_channel_product_status = "New" : ""
                    this.postedProductLists.push(data)
                }else if(postedIndex>=0 && this.postedProductLists[postedIndex].sales_channel_product_status == "Delete"){
                    this.postedProductLists[postedIndex].sales_channel_product_status = ""
                }else if(postedIndex>=0){
                    this.$attrs.action == "Edit" && data.sales_channel_product_status != "New" ? data.sales_channel_product_status = "update" : ""
                    this.postedProductLists[postedIndex] = data
                }
            },
            onChangeAllowCOD(e){
                this.AllowCOD = e.target.checked;
            },
            onChangeAllowStorePickup(e){
                this.AllowStorePickup = e.target.checked;  
            },
            onChangeAllowDragonpay(e){
                this.AllowDragonpay = e.target.checked;  
            },
            onChangeAllowPaymaya(e){
                this.AllowPaymaya = e.target.checked;  
            },
            onChangeAllowDelivery(e){
                this.AllowDelivery = e.target.checked;  
            },
            onChangeAllowCOP(e){
                this.AllowCOP = e.target.checked;  
            },
            onChangeAllowAddToCart(e){
                this.AllowAddToCart = e.target.checked;  
            },
            onChangeAllowIpay88(e){
                this.AllowIpay88 = e.target.checked;  
            },
            uploadIcon() {
                return this.endPoint + 'sales_channels/upload_image?name=icon'
            },
            uploadCarousel() {
                return this.endPoint + 'sales_channels/upload_image?name=carousel'
            },
            handleChange ({ fileList }) {
                if (this.fileListLogo.length > fileList.length){
                    this.fileListLogo.forEach((value, index) => {
                        var searchImage = fileList.findIndex(x=> x.response == value.response)
                        if (searchImage < 0){
                            var imageName = value.response !=null ? value.response : value.name
                            this.deleteImage(imageName)
                        }
                    })
                }
                this.fileListLogo = fileList
            },
            handlePreview (file) {
                this.previewImage = file.url || file.thumbUrl
                this.previewVisible = true
            },
            handleCancel () {
                this.previewVisible = false
            },
            handlePreviewCarousel(file) {
                this.previewImageCarouselDetails = file;
                if(file.url!=undefined && file.url!=null && file.url!=''){
                    this.previewImageCarousel = file.url;
                     var searchImage = this.fileListCarousel.findIndex(x=> x.url == this.previewImageCarousel)
                    this.previewImageCarouselDetails.index = searchImage
                }else if(file.preview!=undefined && file.preview!=null && file.preview!=''){
                    this.previewImageCarousel = file.preview;
                    var searchImage = this.fileListCarousel.findIndex(x=> x.preview == this.previewImageCarousel)
                    this.previewImageCarouselDetails.index = searchImage
                }else if(file.thumbUrl!=undefined && file.thumbUrl!=null && file.thumbUrl!=''){
                    this.previewImageCarousel = file.thumbUrl;
                    var searchImage = this.fileListCarousel.findIndex(x=> x.thumbUrl == this.previewImageCarousel)
                    this.previewImageCarouselDetails.index = searchImage
                }
                this.previewVisibleCarousel = true;
            },
            handleChangeCarousel({ fileList }) {
                if (this.fileListCarousel.length > fileList.length){
                    this.fileListCarousel.forEach((value, index) => {
                        var searchImage = fileList.findIndex(x=> x.response == value.response)
                        if (searchImage < 0){
                            this.deleteImage(value.response)
                        }
                    })
                }
                if(!this.fileListCarouselUploadStatus){
                    this.$notification['error']({
                        message: 'Carousel',
                        description: "Carousel title is required"
                    });
                }else {
                    this.fileListCarousel = fileList
                }
                this.CarouselTitle = null
            },
            handleCancelCarousel() {
                this.previewVisibleCarousel = false
            },
            deleteImage: async function(imageName){
                var response = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channels/delete_image', null,{image_name:imageName})
                if(this.$attrs.action == "Edit"){
                    this.updateImages()
                }
            },
            beforeUpload(file) {
                this.fileListCarouselUploadStatus = true;
                if(this.CarouselTitle!=null && this.CarouselTitle!=''){
                    file.title = this.CarouselTitle
                    if(file.title!=undefined){
                        this.fileListCarousel = [...this.fileListCarousel, file];
                        if(this.$attrs.action == "Edit"){
                            setTimeout(function () { this.updateImages() }.bind(this), 2000)
                           this.updateImages()
                        }
                    }
                }else {
                    this.fileListCarouselUploadStatus = false;
                    return false
                }
            },
            updateImages: async function(){
                let file = null;
                if(this.fileList.length > 0){
                    if (this.fileList[0].response == undefined){
                        file = this.fileList[0].name
                    } else {
                        file = this.fileList[0].response
                    }
                }
                var updateImages = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channels/update_images', null,{id: this.id, icon_name: file, carousel: this.fileListCarousel})
            },
            async massAssign (){
                this.massAssignLoading = true
                if (this.$attrs.action == 'Create' || this.$attrs.action == 'resume_create'){
                    for (let index = 0; index < this.massAssignList.length; index++) {
                        var value = (this.chooseCollection === '') ? -1 : this.chooseCollection
                        this.postedProductLists[this.massAssignList[index]].collection_index = value
                        if(index+1 == this.massAssignList.length){
                            this.massAssignList = []
                            this.chooseCollection = null
                        }
                    }
                }else{
                    var sales_channel_collection_id = (this.chooseCollection!=null && this.chooseCollection!=undefined && this.chooseCollection!=="" && this.chooseCollection>=0) ? this.collections[this.chooseCollection].id : null
                    var response = await HTTPRequest.postRequest(component_x.endPoint + 'sales_channels/mass_assign_collection', null,{id:this.id,sales_channel_product_ids:this.massAssignList,sales_channel_collection_id:sales_channel_collection_id})
                    if (response["error"] == undefined){
                        this.$notification['success']({
                            message: 'Successful Operation',
                        });
                    }else{
                        this.errors = response["error"].split(",")
                    }
                    this.massAssignList = []
                    this.chooseCollection = null
                }
                this.getPostedProductData()
                this.massAssignLoading = false
            },
            splitArray(array){
                var arr = array.split(',')
                return arr
            },
            onChangeSequenceNo(id,value){
                var postedIndex = -1
                postedIndex = this.postedProductLists.findIndex(x=> x.id == id)
                if (postedIndex<0){
                    postedIndex = this.postedProductLists.findIndex(x=> x.product_id ==id)
                }
                if (postedIndex >= 0){
                    this.postedProductLists[postedIndex].sequence_no = value
                    this.postedProductLists[postedIndex].temp_sequence_no = value
                    if(this.postedProductLists[postedIndex].sales_channel_product_status!="New"){
                        this.postedProductLists[postedIndex].sales_channel_product_status = "update"
                    }
                }
            },
            getRandomInt(min, max,index) {
                min = Math.ceil(min);
                max = Math.floor(max);
                var randonValue = Math.floor(Math.random() * (max - min + 1)) + min;
                var search = this.postedProductLists.findIndex(x=> x.temp_sequence_no == randonValue)
                if (search<0){
                    this.postedProductLists[index].sequence_no = randonValue
                    this.postedProductLists[index].temp_sequence_no = randonValue
                    if(this.postedProductLists[index].sales_channel_product_status!="New"){
                        this.postedProductLists[index].sales_channel_product_status = "update"
                    }
                }else {
                    this.getRandomInt(min,max,index)
                }
            },
            saveCarouselCaption(index,title){
                this.successMessage = null
                if(title==null || title ==''){
                    this.editCarouoselErrors = []
                    this.editCarouoselErrors.push(ValidateField.required('title', this.title));
                }else {
                    this.successMessage = "Successful Operation"
                    this.fileListCarousel[index].title = title
                }
            },
            allSiteData: async function(){
                this.options1.ajaxURL = this.endPoint + 'sites'
                table1 = new Tabulator("#branches-table", this.options1);
                this.runSite = false;
            },
            addSiteButton (cell, formatterParams){
                let id = cell.getRow().getData().id
                var button = ""
                var postedIndex = 0
                if (this.$attrs.action == 'Create'){
                    postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == id)
                }else{
                    postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == id)
                    if (postedIndex>=0){
                        if (this.supportedSiteList[postedIndex].site_status == "Delete"){
                            postedIndex = -1
                        }
                    }else{
                        postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == id)
                    }
                }
                if (postedIndex <0){
                    button += '<button id="' + id + '" name="Add" class="btn btn-success btn-sm">Add</button>'
                }else{
                    button += '<button id="' + id + '" name="Undo" class="btn btn-sm btn-warning">Undo</button>'
                }
                return button
            },
            selectSiteAction: function(e, cell){
                if(e.target.id!=""){
                    this.errors =[]
                    switch (e.target.name) {
                        case "Add":
                            if (this.$attrs.action == 'Create'){
                                var postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == e.target.id)
                            }else{
                                var postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == e.target.id)
                                if (postedIndex<0){
                                    var postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == e.target.id)
                                }
                            }
                            this.addSupportedSite(cell.getRow().getData(),postedIndex)
                        break;
                        case "Undo":
                            if (this.$attrs.action == 'Create'){
                                var postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == e.target.id)
                            }else{
                                var postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == e.target.id)
                                if (postedIndex<0){
                                    var postedIndex = this.supportedSiteList.findIndex(x=> x.site_id == e.target.id)
                                }
                            }
                            if (this.$attrs.action == "Edit"){
                                if(this.supportedSiteList[postedIndex].site_status != undefined){
                                    if (this.supportedSiteList[postedIndex].site_status != "New"){
                                        this.supportedSiteList[postedIndex].site_status = "Delete"
                                    }else{
                                        this.supportedSiteList.splice(postedIndex,1)
                                    }
                                }else{
                                    this.supportedSiteList[postedIndex].site_status = "Delete"
                                }
                            }else{
                                this.supportedSiteList.splice(postedIndex,1)
                            }
                        break;
                        default:
                        break;
                    }
                    this.allSiteData()
                }
            },
            onChangeSettingsTab(activeKey){
                if(activeKey==3){
                    setTimeout(function () { this.allSiteData() }.bind(this), 100)
                    if(this.defaultSitesList.length <=0){
                        this.getallSites()
                    }
                }
            },
            getallSites:async function(){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channels/get_all_sites', null)  
                this.defaultSitesList = response
            },
            addSupportedSite(data,postedIndex){
                var arr = {site_id:data.id}
                if (postedIndex <0){
                    data.collection_index = ''
                    this.$attrs.action == "Edit" ? arr.site_status = "New" : ""
                    this.supportedSiteList.push(arr)
                }else if(postedIndex>=0 && this.supportedSiteList[postedIndex].site_status == "Delete"){
                    this.supportedSiteList[postedIndex].site_status = ""
                }else {
                    this.errors.push("store " +this.supportedSiteList[postedIndex].name + " is already exist")
                }
            },
            getAllSubLocation:async function(){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channels/get_all_sublocation?site_id='+this.siteId, null) 
                this.sublocationList = response
                if(this.selectedSublocationId == null){
                    var siteIndex = this.defaultSitesList.findIndex(x=> x.id == this.siteId)
                    if (siteIndex>=0){
                        this.selectedSublocationId = this.defaultSitesList[siteIndex].sublocation_id
                    }
                }else if(this.selectedSublocationId != null){
                    var sublocationIndex = this.sublocationList.findIndex(x=> x.id == this.selectedSublocationId)
                    if (sublocationIndex<0){
                        var siteIndex = this.defaultSitesList.findIndex(x=> x.id == this.siteId)
                        if (siteIndex>=0){
                            this.selectedSublocationId = this.defaultSitesList[siteIndex].sublocation_id
                        }
                    }
                }
            },
            onChangeInventoryPercentage(value) {
                this.inventoryPercentage = value;
            },
            inventoryValidation(){
                this.errors = [];
                this.errors.push(ValidateField.required('Default Site', this.siteId));
                if (this.inputTypeStatus!=1){
                    this.errors.push(ValidateField.required('Sublocation', this.selectedSublocationId));
                    this.errors.push(ValidateField.greaterThanZero('Inventory Percentage', this.inventoryPercentage, 'Inventory Percentage greater than zero'));
                }
                this.errors = this._.compact(this.errors);
                return this.errors.length;
            },
            closeFilter() {
                this.advanceFilter(false);
            },
            advanceFilter(value) {
                this.toggleAdvanceFilter = value;
                if (this.toggleAdvanceFilter == true) {
                    this.toggleLabel = "Collapse Filter";
                } else {
                    this.toggleLabel = "Advanced Filter";
                }
            },
            changeParams(params, actualParams) {
                this.tags = [];
                this.advanceFilterParamsToString = ""
                var parametersCopy = this.parentParams;
                var mergedParameters = Object.assign({}, parametersCopy, params);
                this.params = mergedParameters;
                this.filterParams = actualParams;
                const defaultFilters = [
                    "status",
                    "is_non_trade",
                    "stock_status",
                    "category_name",
                    "supplier_name",
                    "start_date",
                    "brand_names",
                    "sub_brand_names",
                    "tag_names",
                    "inputCategory",
                    "inputBrand",
                    "inputSubBrand",
                    "inputSupplierType",
                    "inputSupplier",
                    "inputDate",
                    "statusFilter",
                    "inputTag",
                    "inputProductGroup",
                    "product_group_names",
                    "inputProductGrade",
                    "inputRetailPrice",
                    "dateString",
                    "isNonTrade",
                    "stockStatus",
                    "inputProductSeriesName",
                    "inputProductSeriesDate",
                    "product_series_name",
                ];

                if (Object.keys(this.parentParams)[0] != undefined  && Object.keys(this.parentParams)[0] != "") {
                    this.tags.push(
                    Object.keys(this.parentParams)[0] +
                        ":" +
                        Object.values(this.parentParams)[0]
                    );
                    this.advanceFilterParamsToString+= "&" + Object.keys(this.parentParams)[0] + "=" + Object.values(this.parentParams)[0]
                }

                Object.keys(params).forEach(function (key) {
                    if (!defaultFilters.includes(key)) {
                        component_x.tags.push(`${key}: ${params[key]}`);
                        if (params[key] != undefined && params[key] != null && params[key]!=""){
                            component_x.advanceFilterParamsToString+= "&" + key + "=" + params[key]
                        }
                    }
                });

                if (params["status"] != undefined && params["status"] != "") {
                    switch (params["status"]) {
                    case "A":
                        this.tags.push("Status: Active");
                        break;
                    case "I":
                        this.tags.push("Status: Inactive");
                        break;
                    case "P":
                        this.tags.push("Status: Phased Out");
                        break;
                    case "D":
                        this.tags.push("Status: Deleted ");
                        break;
                    }
                    this.advanceFilterParamsToString+="&status=" + params["status"]
                }

                if (params["is_non_trade"] != undefined && params["is_non_trade"] != "") {
                    this.tags.push("Non-trade: " + params["is_non_trade"]);
                    this.advanceFilterParamsToString+="&is_non_trade=" + params["is_non_trade"]
                }

                if (params["stock_status"] != undefined && params["stock_status"] != "") {
                    switch (params["stock_status"]) {
                    case "1":
                        this.tags.push("Stock: Out of Stock");
                        break;
                    case "2":
                        this.tags.push("Stock: On Stock");
                        break;
                    case "3":
                        this.tags.push("Stock: Negative Stock");
                        break;
                    }
                    this.advanceFilterParamsToString+="&stock_status=" + params["stock_status"]
                }

                if (params["category_name"] != undefined && params["category_name"] != "") {
                    this.tags.push("Category: " + params["category_name"]);
                    this.advanceFilterParamsToString+="&category_name=" + params["category_name"]
                }

                if (params["supplier_name"] != undefined && params["supplier_name"] != "") {
                    this.tags.push("Supplier: " + params["supplier_name"]);
                    this.advanceFilterParamsToString+="&supplier_name=" + params["supplier_name"]
                }

                if (params["start_date"] != undefined && params["start_date"] != "") {
                    this.tags.push(
                    "Price Change Date: " +
                        params["start_date"] +
                        " to " +
                        params["end_date"]
                    );
                    this.advanceFilterParamsToString+="&start_date=" + params["start_date"]
                }

                if (params["brand_names"] != undefined && params["brand_names"] != "") {
                    for (var i = 0; i < params["brand_names"].length; i++) {
                    this.tags.push("Brand: " + params["brand_names"][i]);
                    }
                    this.advanceFilterParamsToString+="&brand_names=" + params["brand_names"]
                }

                if (params["sub_brand_names"] != null && params["sub_brand_names"] != "") {
                    params["sub_brand_names"].forEach((el) => {
                    this.tags.push("Sub Brand: " + el)
                    })
                    this.advanceFilterParamsToString+="&sub_brand_names=" + params["sub_brand_names"]
                }


                if (params["product_group_names"] != null && params["product_group_names"] != "") {
                    params["product_group_names"].forEach((el) => {
                    this.tags.push("Product Group: " + el)
                    })
                    this.advanceFilterParamsToString+="&product_group_names=" + params["product_group_names"]
                }

                if (params["product_series_name"] != null && params["product_series_name"] != "") {
                    params["product_series_name"].forEach((el) => {
                    this.tags.push("Product Series: " + el)
                    })
                    this.advanceFilterParamsToString+="&product_series_name=" + params["product_series_name"]
                }

                if (params["tag_names"] != undefined && params["tag_names"] != "") {
                    for (var j = 0; j < params["tag_names"].length; j++) {
                    this.tags.push("Tag: " + params["tag_names"][j]);
                    }
                    this.advanceFilterParamsToString+="&tag_names=" + params["tag_names"]
                }

                if (actualParams == null) {
                    this.params = {};
                    this.parentParams = {};
                    this.tags = [];
                }

                let exclude = ["brand_id", "product_group_id", "sub_brand_id"]
                exclude.forEach((item) => {
                    this.tags = this.tags.filter((tag) => {
                    return tag.indexOf(item) !== 0;
                    })
                })
                this.advanceFilter(false);
                this.allProductsData()
            },
            handleClose(removedTag) {
                var tagArray = removedTag.split(": ");
                switch (tagArray[0]) {
                    case "Supplier":
                    delete this.filterParams["inputSupplier"];
                    delete this.params["supplier_id"];
                    break;
                    case "Price Change Date":
                    delete this.filterParams["inputDate"];
                    delete this.filterParams["dateString"];
                    delete this.params["start_date"];
                    delete this.params["end_date"];
                    break;
                    case "Status":
                    this.filterParams["statusFilter"] = "0";
                    delete this.params["status"];
                    break;
                    case "Category":
                    delete this.filterParams["inputCategory"];
                    delete this.params["category_id"];
                    delete this.params["section_id"];
                    delete this.params["division_id"];
                    delete this.params["department_id"];
                    break;
                    case "Brand":
                    var brandIndex = this.params["brand_names"].indexOf(tagArray[1]);
                    this.params["brand_id"].splice(brandIndex, 1);
                    this.params["brand_names"].splice(brandIndex, 1);
                    break;
                    case "Sub Brand":
                    var subBrandIndex = this.params["sub_brand_names"].indexOf(tagArray[1]);
                    this.params["sub_brand_id"].splice(subBrandIndex, 1);
                    this.params["sub_brand_names"].splice(subBrandIndex,1);
                    break;
                    case "Product Group":
                    var productGroupIndex = this.params["product_group_names"].indexOf(tagArray[1]);
                    this.params["product_group_id"].splice(productGroupIndex, 1);
                    this.params["product_group_names"].splice(productGroupIndex, 1);
                    break;
                    case "Product Series":
                    var productSeriesIndex = this.params["product_series_name"].indexOf(tagArray[1]);
                    this.params["product_series_name"].splice(productSeriesIndex, 1);
                    break;
                    case "Tag":
                    var tagIndex = this.params["tag_names"].indexOf(tagArray[1]);
                    this.params["product_line_id"].splice(tagIndex, 1);
                    this.params["tag_names"].splice(tagIndex, 1);
                    // this.filterParams["inputTag"].splice(tagIndex, 0)
                    break;
                    case "name":
                    delete this.parentParams["name"];
                    delete this.params["name"];
                    break;
                    case "id":
                    delete this.parentParams["id"];
                    delete this.params["id"];
                    break;
                    case "barcode":
                    delete this.parentParams["barcode"];
                    delete this.params["barcode"];
                    break;
                    case "stock_no":
                    delete this.parentParams["stock_no"];
                    delete this.params["stock_no"];
                    break;
                    case "reference_code":
                    delete this.parentParams["reference_code"];
                    delete this.params["reference_code"];
                    break;
                    case "shelf_code":
                    delete this.parentParams["shelf_code"];
                    delete this.params["shelf_code"];
                    break;
                    case "Non-trade":
                    delete this.parentParams["is_non_trade"];
                    delete this.params["is_non_trade"];
                    break;
                    case "Stock":
                    delete this.filterParams["stockStatus"];
                    delete this.params["stock_status"];
                    delete this.parentParams["stock_status"];
                    break;
                    default:
                    delete this.filterParams[tagArray[0]];
                    delete this.params[tagArray[0]];
                    delete this.parentParams[tagArray[0]];
                    break;
                }
                const tags = this.tags.filter((tag) => tag !== removedTag);
                this.tags = tags;
                this.changeParams(this.params, this.filterParams)
            },
            async AddAllProducts(){
                this.AddAllProductsLoading = true
                var products = []
                table.getData().forEach((value, index) => {
                    var postedIndex = -1
                    if (this.$attrs.action == 'Create' || this.$attrs.action=="resume_create"){
                        postedIndex = this.postedProductLists.findIndex(x=> x.id == value.id)
                        value.tag = null
                        this.addProduct(value,postedIndex)
                    }else{
                        if (value.sales_channel_product_id == null || value.sales_channel_product_id < 0){
                            products.push(value)
                        }
                    }
                });
                if (this.$attrs.action=="Create" || this.$attrs.action=="resume_create") {
                    this.updatePostedData()
                }else{
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channels/mass_add_products', null, {id:this.id,sales_channel_products:products})
                    if (post_request["error"] == undefined){
                        this.$notification['success']({
                            message: 'Successful Operation',
                        });
                    }else{
                        this.errors = post_request["error"].split(",")
                    }
                }
                this.allProductsData()
                await table.redraw(true);
                this.tabulatorCurrentPage = 0
                this.AddAllProductsLoading = false
            },
            async UndoAllProducts(){
                this.UndoAllProductsLoading = true
                var products = []
                table.getData().forEach((value, index) => {
                    var postedIndex = -1
                    if (this.$attrs.action == 'Create' || this.$attrs.action=="resume_create"){
                        postedIndex = this.postedProductLists.findIndex(x=> x.id == value.id)
                    }else{
                        if (value.sales_channel_product_id != null || value.sales_channel_product_id > 0){
                            products.push(value)
                        }
                    }
                });
                if (this.$attrs.action=="Create" || this.$attrs.action=="resume_create") {
                    this.updatePostedData()
                }else{
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channels/mass_delete_products', null, {id:this.id,sales_channel_products:products})
                    if (post_request["error"] == undefined){
                        this.$notification['success']({
                            message: 'Successful Operation',
                        });
                    }else{
                        this.errors = post_request["error"].split(",")
                    }
                }
                this.allProductsData()
                await table.redraw(true);
                this.tabulatorCurrentPage = 0
                this.UndoAllProductsLoading = false
            },
            setPages () {
                this.itemListPagination.pages = []
                let numberOfPages = Math.ceil(this.countPostedProduct / this.itemListPagination.perPage);
                this.itemListPagination.numberOfPages = numberOfPages;
                if (this.itemListPagination.page > numberOfPages){
                    this.itemListPagination.page = numberOfPages || 1
                    this.itemListPagination.itemListPaginatedData = this.paginate(this.postedProductLists)
                    this.itemListPagination.pages = [1]
                }
                for (let index = 1; index <= numberOfPages; index++) {
                    this.itemListPagination.pages.push(index);
                }
                let numShown = 10;   // This sets the number of page tabs
                numShown = Math.min(numShown, numberOfPages);
                let first = this.itemListPagination.page - Math.floor(numShown / 2);
                first = Math.max(first, 1);
                first = Math.min(first, numberOfPages - numShown + 1);
                this.itemListPagination.pages = [...Array(numShown)].map((k,i) => i + first);
            },
            paginate (datas) {
                var filterProducts = datas.filter(function(data) {
                    return data.sales_channel_product_status != "Delete";
                });
                this.countPostedProduct = filterProducts.length
                let page = this.itemListPagination.page || 1;
                let perPage = this.itemListPagination.perPage || 10;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);
                return  filterProducts.slice(from, to);
            },
            updatePostedData(){
                this.itemListPagination.itemListPaginatedData = this.paginate(this.postedProductLists)
                this.setPages()
            },
            changeOrderSyncing(selectedItem){
                this.orderSyncing = selectedItem;
            },
            changeOrderInvoice(selectedItem){
                this.orderInvoice = selectedItem;
            },
            getTabulatorPaginationDetails(){
                if (this.setTable){
                    this.tabulatorPaginationDetails.pageCount = table.getPageMax()
                    this.tabulatorPaginationDetails.currentPage = table.getPage()
                    this.tabulatorPaginationDetails.buttons = table.modules.page.pagesElement.children
                    this.tabulatorPaginationDetails.perPageSizeOption = table.modules.page.pageSizeSelect.children
                    this.tabulatorPaginationDetails.perPageSize = table.modules.page.size
                }
            },
            async setTabulatorPage(status,page){
                switch (status) {
                    case "prev":
                        table.previousPage();
                    break;
                    case "number":
                        table.setPage(page);
                    break;
                    case "next":
                        table.nextPage();
                    break;
                    default:
                    break;
                }
                this.getTabulatorPaginationDetails()
            },
            async setPerPageSize (value){
                table.setPageSize(value)
                this.getTabulatorPaginationDetails()
            },
            removeItemProduct: async function(id){
                axios({
                method: 'delete',
                url: this.endPoint + 'sales_channel_products/' + id,
                headers: {
                    Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                    "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
                },
                })
                .then(function () {
                    component_x.$notification['success']({
                        message: 'Successfully deleted',
                        description: "",
                    });
                    component_x.getPostedProductData()
                })
            },
            getCollectionName(id){
                var index = -1
                if (this.$attrs.action == 'Create' || this.$attrs.action=="resume_create"){
                    index = id
                }else{
                    var index = this.collections.findIndex(p => p.id == id)
                }
                if (index >-1){
                    try {
                        return this.collections[index].collection_name
                    } catch (error) {
                        return "Catalog"
                    }
                }else{
                    return "Catalog"
                }
            }
        },
    };
</script>
<style>
    .ant-list-header, .ant-list-footer {
        padding-top: 6px;
        padding-bottom: 6px;
    }
    .custom-scrollbar-css::-webkit-scrollbar {
        width: 5px!important;
    }
    .custom-scrollbar-css::-webkit-scrollbar-track {
    background: #eee!important;
    }
    .custom-scrollbar-css::-webkit-scrollbar-thumb {
    border-radius: 1rem!important;
    background-color: #00d2ff!important;
    background-image: linear-gradient(to top, #00d2ff 0%, #3a7bd5 100%)!important;
    }
    .custom-scrollbar-css {
        overflow-y: scroll;
    }

</style>
<style lang='scss'>
    @import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
    .iframe-container {
    overflow: hidden;
    padding-top: 56.25%; /* 16:9*/
    position: relative;
    }

    .iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    }
    .hide {
        visibility: hidden !important;
    }
</style>